// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Security Settings (two_factor_autentication) — all rules scoped under .tf-sec-page (BEM: tf-sec-page__*).
 */

.tf-sec-page {
  --tf-bg: #f4f6f8;
  --tf-card: #ffffff;
  --tf-border: #F3F4F6;
  --tf-text: #101828;
  --tf-muted: #9ca3af;
  --tf-muted2: #94a3b8;
  --tf-green: #00a870;
  --tf-badge-bg: #fff4e6;
  --tf-badge-text: #c27803;
  --tf-btn-bg: #f1f5f9;
  --tf-btn-text: #1e293b;
  --tf-radius: 16px;
  --tf-radius-sm: 6px;
  box-sizing: border-box;
  width: 100%;
  min-height: 100%;
  padding-left: 40px;
  padding-right: 167px;

}

.tf-sec-page *,
.tf-sec-page *::before,
.tf-sec-page *::after {
  box-sizing: border-box;
}

/* Hero (div.tf-sec-page__hero — no <header>) */
.tf-sec-page__hero {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  margin: 36px 0 10px;
  flex-wrap: wrap;
}

.tf-sec-page__hero-content {
  flex: 1 1 280px;
  min-width: 0;
}

.tf-sec-page__hero-title {
  margin: 0 0 12px;
  font-size: 40px;
  font-weight: 600;
  letter-spacing: -0.03em;
  color: #ebebeb;
  line-height: 1.2;
}

body.light_theme .tf-sec-page__hero-title {
  color: #101828;
}

.tf-sec-page__hero-description {
  margin: 20px 0 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.55;
  color: var(--tf-muted);
  max-width: 760px;
}

.tf-sec-page__hero-media {
  flex: 0 0 auto;
  width: min(200px, 42vw);
  max-width: 220px;
}

.tf-sec-page__hero-media img {
  display: block;
  width: 100%;
  height: auto;
}

/* Card */
.tf-sec-page__card {
  background: none;
  border: 1px solid #f3f4f60a;
  border-radius: var(--tf-radius);
  margin-bottom: 40px;
  overflow: hidden;
  box-shadow: 0px 1px 3px #00000010;
}

body.light_theme .tf-sec-page__card {
  background: #ffffff;
  border: 1px solid #f3f4f630;
}

/* Card top block (div.tf-sec-page__card-header — no <header>) */
.tf-sec-page__card-header {
  padding: 24px;
  border-bottom: 1px solid #f3f4f60a;
}

body.light_theme .tf-sec-page__card-header {
  border-bottom: 1px solid #f3f4f636;
}

.tf-sec-page__card-title {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #f8f8f8;

  letter-spacing: -0.02em;
}

body.light_theme .tf-sec-page__card-title {
  color: #101828;
}

.tf-sec-page__card-subtitle {
  margin: 8px 0 0;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.5;
  color: var(--tf-muted);
}

.tf-sec-page__card-body {
  padding: 0 0 8px;
}

/* Row */
.tf-sec-page__row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px 16px;
  padding: 24px 70px 24px 24px;
  border-top: 1px solid #f3f4f60a;
}

body.light_theme .tf-sec-page__row {
  border-top: 1px solid #f3f4f638;
}


.tf-sec-page__card-body .tf-sec-page__row:first-of-type {
  border-top: none;
}

.tf-sec-page__row-main {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  min-width: 0;
  width: 710px;
  max-width: 100%;
}

.tf-sec-page__row-icon-wrap {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tf-sec-page__row-icon {
  width: 36px;
  height: 36px;
  object-fit: contain;
}

.tf-sec-page__row-body {
  min-width: 0;
}

.tf-sec-page__card .email_verify {
  margin-right: 22px;
}

.tf-sec-page__row-heading-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}

.tf-sec-page__row-heading {
  font-size: 18px;
  font-weight: 600;
  color: #eeeeee;
}

body.light_theme .tf-sec-page__row-heading {
  color: #101828;
}

.tf-sec-page__badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 5px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 500;
  background: #FBF1DF00;
  color: #D1AA67;
  line-height: 1.3;
}

body.light_theme .tf-sec-page__badge {
  background: #FBF1DF;
  color: #D1AA67;
}

.tf-sec-page__row-description {
  margin: 0;
  font-size: 14px;
  line-height: 1.45;
  font-weight: 400;
  color: #cacaca;
}

body.light_theme .tf-sec-page__row-description {
  color: #4A5565;
}

.tf_checkfill {
  background-color: rgb(195 197 199 / 20%);
  color: #fff;
  width: 20px;
  font-weight: 600;
  height: 20px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

body.light_theme .tf_checkfill {
  background-color: rgb(195 197 199 / 40%);
  color: #242424;
}

.tf-sec-page__row-meta {
  justify-self: end;
  min-width: 142px;
  text-align: right;
}

.tf-sec-page__status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #4A5565;
  font-weight: 500;
}

/* Read-only status (no toggle) — gray pill + check + OFF label */
.tf-sec-page__status--readonly-off {
  gap: 8px;
}

.tf-sec-page__status--readonly-off .tf-sec-page__status-dot {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #9ca3af;
  color: #fff;
  flex-shrink: 0;
}

.tf-sec-page__status--readonly-off .tf-sec-page__status-dot i {
  font-size: 12px;
  line-height: 1;
}

.tf-sec-page__status--readonly-off .tf-sec-page__status-label {
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.08em;
  color: #6b7280;
  text-transform: none;
}

.tf-sec-page__status--success {
  color: var(--tf-green, #00a870);
}

.tf-sec-page__status--success .tf_checkfill {
  background-color: var(--tf-green, #00a870);
  color: #fff;
}

.tf-sec-page__status--success>span {
  color: var(--tf-green, #00a870);
  font-weight: 600;
}

.tf-sec-page__status-email--success {
  color: #f5f5f5;
  font-weight: 600;
}

body.light_theme .tf-sec-page__status-email {
  color: #4A5565;
}

.tf-sec-page__l2sv-row-icons {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 6px;
  max-width: 220px;
  margin-right: 4px;
}

/* One chip per method — same size as email so GA / SMS are equally visible */
.tf-sec-page__l2sv-method {
  display: inline-flex;
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
}

.tf-sec-page__l2sv-method img {
  width: 18px;
  height: 18px;
  object-fit: contain;
  display: block;
}

.tf-sec-page__l2sv-row-icon {
  display: inline-flex;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
}

.tf-sec-page__l2sv-row-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

/* Stack with row icons: avoid 22px margin from .tf-sec-page__card .email_verify */
.tf-sec-page__card .tf-sec-page__l2sv-row-icons .email_verify,
.tf-sec-page__l2sv-row-icons .email_verify {
  margin-right: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.tf-sec-page__fund-pw-status--on {
  color: var(--tf-green, #00a870);
  font-weight: 600;
}

/* Login password row — neutral “on” label (not success green) */
.tf-sec-page__status--login-password {
  color: #615565;
}

.tf-sec-page__login-password-status {
  color: #615565;
  font-weight: 600;
}

.tf-sec-page__status-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #cbd5e1;
  flex-shrink: 0;
}

.tf-sec-page__status-email {
  font-weight: 500;
  font-size: 14px;
  color: #e3e3e3;
}

body.light_theme .tf-sec-page__status-email {
  color: #4A5565;
}

.tf-sec-page__google-badge {
  display: inline-flex;
  align-items: center;
  background-color: #E9E9E9;
  justify-content: center;
  vertical-align: middle;
  width: 24px;
  height: 24px;
  border-radius: 50px;
  padding: 3px;
}

.tf-sec-page__google-badge svg {
  display: block;
}

.tf-sec-page__row-actions {
  justify-self: end;
  min-width: 200px;
  justify-content: end;
  display: flex;
}

.tf-sec-page__row-actions--split {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
  align-items: center;
}

.tf-sec-page__btn--compact {
  min-width: auto;
  padding: 8px 14px;
  flex-shrink: 0;
}

.tf-sec-page__aph-remove-field {
  width: 100%;
  margin-bottom: 14px;
}

.tf-sec-page__aph-remove-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: var(--tf-text, #1e293b);
  margin-bottom: 6px;
}

.tf-sec-page__aph-remove-input {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 12px;
  font-size: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fff;
  color: var(--tf-text, #1e293b);
}

.tf-sec-page__aph-remove-row {
  display: flex;
  gap: 8px;
  align-items: center;
}

.tf-sec-page__aph-remove-row .tf-sec-page__aph-remove-input {
  flex: 1 1;
  min-width: 0;
}

.tf-sec-page__method-list {
  flex-direction: column;
  display: flex;
  gap: 12px;
  margin: 20px 0px 10px;
  text-align: left;
}

.tf-sec-page__method-list .tf-sec-page__btn {
  display: block;
  width: 100%;
  margin-bottom: 8px;
  text-align: left;
  opacity: 0.85;
}

.tf-sec-page__method-list .tf-sec-page__btn.active {
  opacity: 1;
  border: 1px solid currentColor;
}

.tf-sec-page__method-list .tf-sec-page__btn-desc {
  font-size: 12px;
  font-weight: 400;
  opacity: 0.8;
}

.tf-sec-page__btn {
  appearance: none;
  margin: 0;
  padding: 12px 24px;
  min-width: 88px;
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  background: #2b313d52;
  border: 1px solid #44444454;
  border-radius: 50px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
  white-space: nowrap;
}

body.light_theme .tf-sec-page__btn {
  color: var(--tf-btn-text);
  background: #EFF1F5;
  border: 1px solid #eff1f5;
}

.tf-sec-page__btn:hover:not(:disabled) {
  opacity: 0.8;
}

.tf-sec-page__btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.tf-sec-page__btn--danger {

  /* background: #fff;
    border-color: #fecaca; */
  color: #ffffff;
}

.tf-sec-page__btn--danger:hover:not(:disabled) {
  opacity: 0.8;
  /* background: #fef2f2;
  border-color: #ffffff;  */
}

.tf-sec-page__btn--dark {
  color: #fff;
  background: #1e293b;
  border-color: #1e293b;
}

.tf-sec-page__btn--dark:hover:not(:disabled) {
  background: #334155;
  border-color: #334155;
}

@media (max-width: 720px) {
  .tf-sec-page__row {
    grid-template-columns: 1fr;
    align-items: center;
    gap: 12px;
  }

  .tf-sec-page__row-meta,
  .tf-sec-page__row-actions {
    justify-self: stretch;
    text-align: left;
  }

  .tf-sec-page__row-actions .tf-sec-page__btn {
    width: 100%;
  }

  .tf-sec-page__hero-media {
    margin: 0 auto;
  }
}

body.light_theme .tf-sec-page {
  --tf-bg: #f4f6f8;
}

/* Login 2-Step Verification modal */
/* Login 2-Step Verification modal */
.tf-sec-page__l2sv-overlay,
.tf-sec-page__wds-overlay,
.tf-sec-page__daev-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
  z-index: 100000020;
}

body.light_theme .tf-sec-page__l2sv-overlay,
body.light_theme .tf-sec-page__wds-overlay,
body.light_theme .tf-sec-page__daev-overlay {
  background: rgb(255 255 255 / 20%);
  /* border: 1px solid #E1E1E1; */
  box-shadow: none;
}

.tf-sec-page__daev-overlay {
  z-index: 100000021;
}

/* Phone unbound modal (opened from SMS verification toggle) */
.tf-sec-page__unbound-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px;
  z-index: 100000025;
}

body.light_theme .tf-sec-page__unbound-overlay {
  background: rgb(255 255 255 / 20%);
}

/* Portaled to document.body — escapes profile column / overflow stacking */
.tf-sec-page__unbound-overlay--portal {
  z-index: 2147483000;
}

.tf-sec-page__unbound-modal {
  width: 520px;
  max-width: 92vw;
  border-radius: 20px;
  background: #1e202670;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  border: 1px solid rgb(255 255 255 / 8%);
  box-shadow: 0 24px 56px rgba(0, 0, 0, 0.50);
  padding: 26px 24px 22px;
  position: relative;
  text-align: left;
}

body.light_theme .tf-sec-page__unbound-modal {
  background: rgb(255 255 255 / 20%);
  border: 1px solid #e8eaed;
  box-shadow: 0 24px 56px rgba(15, 23, 42, 0.18);
}

.tf-sec-page__unbound-close {
  position: absolute;
  top: 12px;
  right: 14px;
  width: 34px;
  height: 34px;
  border: none;
  background: transparent;
  color: #84888C;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  border-radius: 10px;
  transition: background 0.15s ease, color 0.15s ease;
}

.tf-sec-page__unbound-close:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
}

body.light_theme .tf-sec-page__unbound-close {
  color: #111827;
}

body.light_theme .tf-sec-page__unbound-close:hover {
  background: rgba(17, 24, 39, 0.06);
  color: #111827;
}

.tf-sec-page__unbound-title {
  margin: 2px 0 12px;
  padding-right: 44px;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #ffffff;
}

body.light_theme .tf-sec-page__unbound-title {
  color: #0b0f1a;
}

.tf-sec-page__unbound-subtitle {
  margin: 0 0 22px;
  font-size: 15px;
  line-height: 1.5;
  font-weight: 400;
  color: #84888C;
  max-width: 440px;
}

body.light_theme .tf-sec-page__unbound-subtitle {
  color: #111827;
}

.tf-sec-page__unbound-cta {
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 999px;
  background: #d1aa67;
  color: #0c0d10;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s ease;
}

.tf-sec-page__unbound-cta:hover {
  background: #b99556;
}

body.light_theme .tf-sec-page__unbound-cta {
  background: #2d2e32;
  color: #ffffff;
  font-weight: 500;
}

body.light_theme .tf-sec-page__unbound-cta:hover {
  background: #1a1b1e;
}

/* Bind AGCX Authenticator modal */
.tf-sec-page__bindauth-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100000026;
}

body.light_theme .tf-sec-page__bindauth-overlay {
  background: transparent;
}

.tf-sec-page__bindauth-modal {
  width: 520px;
  max-width: 92vw;
  border-radius: 16px;
  background: #181a20;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 28px 60px rgba(0, 0, 0, 0.50);
  padding: 22px 24px 20px;
  position: relative;
}

body.light_theme .tf-sec-page__bindauth-modal {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  box-shadow: 0 28px 60px rgba(15, 23, 42, 0.24);
}

.tf-sec-page__bindauth-close {
  position: absolute;
  top: 12px;
  right: 14px;
  width: 34px;
  height: 34px;
  border: none;
  background: transparent;
  color: #84888C;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  border-radius: 10px;
  transition: background 0.15s ease, color 0.15s ease;
}

.tf-sec-page__bindauth-close:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
}

body.light_theme .tf-sec-page__bindauth-close {
  color: #111827;
}

body.light_theme .tf-sec-page__bindauth-close:hover {
  background: rgba(17, 24, 39, 0.06);
  color: #111827;
}

.tf-sec-page__bindauth-title {
  margin: 2px 0 10px;
  padding-right: 44px;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #ffffff;
}

body.light_theme .tf-sec-page__bindauth-title {
  color: #0b0f1a;
}

.tf-sec-page__bindauth-subtitle {
  margin: 0 0 18px;
  font-size: 14px;
  line-height: 1.55;
  color: #84888C;
  max-width: 460px;
}

body.light_theme .tf-sec-page__bindauth-subtitle {
  color: #4b5563;
}

.tf-sec-page__bindauth-cta {
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 999px;
  background: #d1aa67;
  color: #0c0d10;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s ease;
}

.tf-sec-page__bindauth-cta:hover {
  background: #e0be2f;
}

body.light_theme .tf-sec-page__bindauth-cta {
  background: #2d2e32;
  color: #ffffff;
  font-weight: 600;
}

body.light_theme .tf-sec-page__bindauth-cta:hover {
  background: #1a1b1e;
}

/* Fund password missing modal */
.tf-sec-page__fundpw-overlay {
  position: fixed;
  inset: 0;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.6);
  justify-content: center;
  z-index: 100000027;
}

body.light_theme .tf-sec-page__fundpw-overlay {
  background-color: rgb(255 255 255 / 20%);
}

.tf-sec-page__fundpw-modal {
  width: 520px;
  max-width: 92vw;
  border-radius: 16px;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  background: #1e202670;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.50);
  padding: 22px 24px 20px;
  position: relative;
}

body.light_theme .tf-sec-page__fundpw-modal {
  background: rgb(255 255 255 / 20%);
  border: 1px solid #e5e7eb;
  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.24);
}

.tf-sec-page__fundpw-close {
  position: absolute;
  top: 12px;
  right: 14px;
  width: 34px;
  height: 34px;
  border: none;
  background: transparent;
  color: #84888C;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  border-radius: 10px;
  transition: background 0.15s ease, color 0.15s ease;
}

.tf-sec-page__fundpw-close:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
}

body.light_theme .tf-sec-page__fundpw-close {
  color: #111827;
}

body.light_theme .tf-sec-page__fundpw-close:hover {
  background: rgba(17, 24, 39, 0.06);
  color: #111827;
}

.tf-sec-page__fundpw-title {
  margin: 2px 0 10px;
  padding-right: 44px;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #ffffff;
}

body.light_theme .tf-sec-page__fundpw-title {
  color: #0b0f1a;
}

.tf-sec-page__fundpw-subtitle {
  margin: 0 0 18px;
  font-size: 14px;
  line-height: 1.55;
  color: #84888C;
  max-width: 460px;
}

body.light_theme .tf-sec-page__fundpw-subtitle {
  color: #4b5563;
}

.tf-sec-page__fundpw-cta {
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 999px;
  background: #d1aa67;
  color: #0c0d10;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s ease;
}

.tf-sec-page__fundpw-cta:hover {
  background: #e0be2f;
}

body.light_theme .tf-sec-page__fundpw-cta {
  background: #2d2e32;
  color: #ffffff;
  font-weight: 600;
}

body.light_theme .tf-sec-page__fundpw-cta:hover {
  background: #1a1b1e;
}

/* Fund password — pre-navigation confirm (24h lock warning) */
.tf-sec-page__fpw-confirm-modal {
  width: min(560px, 92vw);
  border-radius: 28px;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  background: #1e202670;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 28px 60px rgba(0, 0, 0, 0.50);
  padding: 28px 28px 24px;
  position: relative;
  text-align: center;
}

body.light_theme .tf-sec-page__fpw-confirm-modal {
  background: rgb(255 255 255 / 20%);
  border: 1px solid #e5e7eb;
  box-shadow: 0 28px 60px rgba(15, 23, 42, 0.24);
}

.tf-sec-page__fpw-confirm-close {
  position: absolute;
  top: 12px;
  right: 14px;
  width: 34px;
  height: 34px;
  border: none;
  background: transparent;
  color: #84888C;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  border-radius: 10px;
  transition: background 0.15s ease, color 0.15s ease;
}

.tf-sec-page__fpw-confirm-close:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
}

body.light_theme .tf-sec-page__fpw-confirm-close {
  color: #111827;
}

body.light_theme .tf-sec-page__fpw-confirm-close:hover {
  background: rgba(17, 24, 39, 0.06);
  color: #111827;
}

.tf-sec-page__fpw-confirm-art {
  position: relative;
  width: 200px;
  /* height: 132px; */
  margin: 0 auto 8px;
}

.tf-sec-page__fpw-confirm-badge {
  position: absolute;
  border-radius: 50%;
  z-index: 0;
}

.tf-sec-page__fpw-confirm-badge--lime {
  width: 46px;
  height: 46px;
  background: #bef264;
  top: 6px;
  right: 10px;
}

.tf-sec-page__fpw-confirm-badge--blue {
  width: 38px;
  height: 38px;
  background: #2563eb;
  bottom: 14px;
  left: 6px;
}

.tf-sec-page__fpw-confirm-shield {
  position: relative;
  z-index: 1;
  display: block;
  width: 100%;
  height: auto;
  margin: 22px auto 0;
}

.tf-sec-page__fpw-confirm-title {
  margin: 15px 0 12px;
  padding: 0 36px;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: -0.45px;
  line-height: 1.35;
  color: #ffffff;
}

.passkey-modal-overlay.disable_ga_overlay .passkey-modal {
  width: 540px;
}

body.light_theme .tf-sec-page__fpw-confirm-title {
  color: #0b0f1a;
}

.withdraw_sec_req_modal.sec-req-invert-icons.security-verification-requirements.dark_theme_white_icons_popup .withdraw_sec_req_left img {
  filter: brightness(0) invert(0);
}

body.light_theme .withdraw_sec_req_modal.sec-req-invert-icons.security-verification-requirements.dark_theme_white_icons_popup .withdraw_sec_req_left img {
  filter: brightness(0) invert(1);
}

.tf-sec-page__fpw-confirm-body {
  margin: 0 auto 22px;
  max-width: 450px;
  font-size: 14px;
  /* font-weight: 500; */
  line-height: 1.55;
  color: #84888C;
}

body.light_theme .tf-sec-page__fpw-confirm-body {
  color: #6b7280;
}

.tf-sec-page__fpw-confirm-hours {
  font-weight: 700;
  color: #ea580c;
}

.tf-sec-page__fpw-confirm-actions {
  display: flex;
  gap: 12px;
  align-items: stretch;
}

.tf-sec-page__fpw-confirm-cancel,
.tf-sec-page__fpw-confirm-ok {
  flex: 1 1;
  min-height: 48px;
  border: none;
  border-radius: 999px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.tf-sec-page__fpw-confirm-cancel {
  max-width: 150px;
  background: #2b3139;
  color: #eaecef;
}

.tf-sec-page__fpw-confirm-cancel:hover {
  background: #3a414b;
}

body.light_theme .tf-sec-page__fpw-confirm-cancel {
  background: #e8eaed;
  color: #111827;
}

body.light_theme .tf-sec-page__fpw-confirm-cancel:hover {
  background: #dce0e6;
}

.tf-sec-page__fpw-confirm-ok {
  background: #d1aa67;
  color: #0c0d10;
}

.tf-sec-page__fpw-confirm-ok:hover {
  background: #c59f5e;
}

body.light_theme .tf-sec-page__fpw-confirm-ok {
  background: #2d2e32;
  color: #ffffff;
}

body.light_theme .tf-sec-page__fpw-confirm-ok:hover {
  background: #1a1b1e;
}

/* Login 2-Step Verification modal */
.tf-sec-page__l2sv-modal {
  width: 628px;
  max-width: 92vw;
  border-radius: 14px;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  border: 1px solid rgb(255 255 255 / 6%);
  box-shadow: 0 28px 60px rgba(0, 0, 0, 0.50);
  padding: 24px 24px 40px;
  position: relative;
  background-color: #1e202670;
}

body.light_theme .tf-sec-page__l2sv-modal {
  background-color: rgb(255 255 255 / 20%);
  border: 1px solid #E1E1E1;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18);
}

.tf-sec-page__l2sv-close {
  position: absolute;
  top: 12px;
  right: 14px;
  width: 34px;
  height: 34px;
  border: none;
  background: transparent;
  color: #84888C;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  border-radius: 10px;
  transition: background 0.15s ease, color 0.15s ease;
}

.tf-sec-page__l2sv-close:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
}

body.light_theme .tf-sec-page__l2sv-close {
  color: #111827;
}

body.light_theme .tf-sec-page__l2sv-close:hover {
  background: rgba(17, 24, 39, 0.06);
  color: #111827;
}

.tf-sec-page__l2sv-title {
  margin: 2px 0 6px;
  padding-right: 44px;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #ffffff;
}

body.light_theme .tf-sec-page__l2sv-title {
  color: #070808;
}

.tf-sec-page__l2sv-subtitle {
  margin: 0 0 14px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.45;
  color: #84888C;
  max-width: 420px;
}

body.light_theme .tf-sec-page__l2sv-subtitle {
  color: #84888c;
}

.tf-sec-page__l2sv-list {
  margin-top: 10px;
}

.tf-sec-page__l2sv-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 18px 4px;
}

.tf-sec-page__l2sv-left {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.tf-sec-page__l2sv-icon {
  width: 18px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  flex: 0 0 auto;
}

body.light_theme .tf-sec-page__l2sv-icon {
  color: #111827;
}

.tf-sec-page__l2sv-icon img {
  width: 18px;
  height: 18px;
  display: block;
  object-fit: contain;
  filter: invert(1);
}

body.light_theme .tf-sec-page__l2sv-icon img {
  filter: invert(0);
}

.tf-sec-page__l2sv-text {
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tf-sec-page__l2sv-copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.tf-sec-page__l2sv-hint {
  font-size: 12px;
  font-weight: 500;
  color: #8e939c;
  line-height: 1.35;
  white-space: normal;
}

body.light_theme .tf-sec-page__l2sv-hint {
  color: #6b7280;
}

.tf-sec-page__l2sv-switch.is-unbound {
  opacity: 0.55;
}

.tf-sec-page__removed-modal {
  text-align: center;
}

.tf-sec-page__removed-hero {
  display: flex;
  justify-content: center;
  margin: 8px 0 12px;
}

.tf-sec-page__removed-hero img {
  width: 72px;
  height: 72px;
  object-fit: contain;
}

body.light_theme .tf-sec-page__l2sv-text {
  color: #101828;
}

.tf-sec-page__l2sv-switch {
  width: 40px;
  height: 22px;
  border-radius: 999px;
  border: none;
  background: #2b3139;
  cursor: pointer;
  position: relative;
  padding: 0;
  transition: background 0.15s ease;
  flex: 0 0 auto;
}

.tf-sec-page__l2sv-switch.is-on {
  background: #00a870;
}

body.light_theme .tf-sec-page__l2sv-switch {
  background: #DEDFE1;
}

body.light_theme .tf-sec-page__l2sv-switch.is-on {
  background: #111827;
}

.tf-sec-page__l2sv-knob {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  transition: transform 0.15s ease;
}

.tf-sec-page__l2sv-switch.is-on .tf-sec-page__l2sv-knob {
  transform: translateX(18px);
}

/* Withdrawal Settings modal */
.tf-sec-page__wds-modal {
  width: 628px;
  max-width: 92vw;
  border-radius: 14px;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  background: #181a206e;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.50);
  padding: 24px;
  position: relative;
}

body.light_theme .tf-sec-page__wds-modal {
  background: rgb(255 255 255 / 20%);
  border: 1px solid #E1E1E1;
  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.18);
}

.tf-sec-page__wds-close {
  position: absolute;
  top: 12px;
  right: 14px;
  width: 34px;
  height: 34px;
  border: none;
  background: transparent;
  color: #84888C;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  border-radius: 10px;
  transition: background 0.15s ease, color 0.15s ease;
}

.tf-sec-page__wds-close:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
}

body.light_theme .tf-sec-page__wds-close {
  color: #111827;
}

body.light_theme .tf-sec-page__wds-close:hover {
  background: rgba(17, 24, 39, 0.06);
  color: #111827;
}

.tf-sec-page__wds-title {
  margin: 2px 0 6px;
  padding-right: 44px;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #ffffff;
}

body.light_theme .tf-sec-page__wds-title {
  color: #070808;
}

.tf-sec-page__wds-subtitle {
  margin: 0 0 14px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.45;
  color: #84888C;
}

body.light_theme .tf-sec-page__wds-subtitle {
  color: #84888c;
}

.tf-sec-page__wds-note {
  margin: 8px 0 4px;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 13px;
  line-height: 1.4;
}

.tf-sec-page__wds-note--info {
  background: #1e2330;
  color: #93c5fd;
  border: 1px solid #3b82f63d;
}

body.light_theme .tf-sec-page__wds-note--info {
  background: #eff6ff;
  color: #1d4ed8;
  border: 1px solid #bfdbfe;
}

.tf-sec-page__wds-list {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: 10px;
}

body.light_theme .tf-sec-page__wds-list {
  border-top: 1px solid #f1f5f9;
}

.tf-sec-page__wds-item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 14px 4px;
  border-bottom: none;
  background: transparent;
  border-left: none;
  border-right: none;
  border-top: none;
  border-radius: 0;
  text-align: left;
}

.tf-sec-page__wds-item--link {
  cursor: pointer;
}

.tf-sec-page__wds-left {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.tf-sec-page__wds-icon {
  width: 18px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}

.tf-sec-page__wds-icon img {
  width: 18px;
  filter: invert(1);
  height: 18px;
  display: block;
  object-fit: contain;
}

body.light_theme .tf-sec-page__wds-icon img {
  filter: invert(0);
}

.tf-sec-page__wds-text {
  font-size: 18px;
  font-weight: 500;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

body.light_theme .tf-sec-page__wds-text {
  color: #101828;
}

.tf-sec-page__wds-right {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
}

.tf-sec-page__wds-muted {
  font-size: 14px;
  color: #84888C;
  font-weight: 400;
}

body.light_theme .tf-sec-page__wds-muted {
  color: #101828;
}

.tf-sec-page__wds-chev {
  font-size: 18px;
  color: #6b7280;
  line-height: 1;
}

body.light_theme .tf-sec-page__wds-chev {
  color: #9ca3af;
}

.tf-sec-page__wds-switch {
  width: 40px;
  height: 22px;
  border-radius: 999px;
  border: none;
  background: #2b3139;
  cursor: pointer;
  position: relative;
  padding: 0;
  transition: background 0.15s ease;
  flex: 0 0 auto;
}

.tf-sec-page__wds-switch.is-on {
  background: #00a870;
}

body.light_theme .tf-sec-page__wds-switch {
  background: #DEDFE1;
}

body.light_theme .tf-sec-page__wds-switch.is-on {
  background: #111827;
}

.tf-sec-page__wds-knob {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  transition: transform 0.15s ease;
}

.tf-sec-page__wds-switch.is-on .tf-sec-page__wds-knob {
  transform: translateX(18px);
}

.tf-sec-page__wds-radioGroup {
  padding-top: 10px;
}

.tf-sec-page__wds-radioRow {
  width: 100%;
  border: none;
  background: transparent;
  padding: 10px 2px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  text-align: left;
}

.tf-sec-page__wds-radio {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.2);
  background: #181a20;
  flex: 0 0 auto;
}

body.light_theme .tf-sec-page__wds-radio {
  border: 2px solid #d1d5db;
  background: #fff;
}

.tf-sec-page__wds-radioRow.is-selected .tf-sec-page__wds-radio {
  border-color: #d1aa67;
  box-shadow: inset 0 0 0 1px #d1aa67;
}

body.light_theme .tf-sec-page__wds-radioRow.is-selected .tf-sec-page__wds-radio {
  border-color: #111827;
  box-shadow: inset 0 0 0 1px #111827;
}

.tf-sec-page__wds-radioText {
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  text-decoration: underline;
  text-underline-offset: 3px;
}

body.light_theme .tf-sec-page__wds-radioText {
  color: #111827;
}

/* Disable account — email verification modal */
.tf-sec-page__daev-modal {
  width: 539px;
  max-width: 92vw;
  border-radius: 16px;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  background: #181a20a3;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 28px 64px rgba(0, 0, 0, 0.50);
  padding: 24px 24px 20px;
  position: relative;
}

body.light_theme .tf-sec-page__daev-modal {
  background: rgb(255 255 255 / 20%);
  border: 1px solid #E1E1E1;
  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.18);
}

.tf-sec-page__daev-close {
  position: absolute;
  top: 14px;
  right: 16px;
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  color: #84888C;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  border-radius: 10px;
  transition: background 0.15s ease, color 0.15s ease;
}

.tf-sec-page__daev-close:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
}

body.light_theme .tf-sec-page__daev-close {
  color: #111827;
}

body.light_theme .tf-sec-page__daev-close:hover {
  background: rgba(17, 24, 39, 0.06);
  color: #111827;
}

.tf-sec-page__daev-title {
  margin: 0 0 12px;
  padding-right: 40px;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #ffffff;
}

body.light_theme .tf-sec-page__daev-title {
  color: #070808;
}

.tf-sec-page__daev-desc {
  margin: 0 0 18px;
  width: 83%;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.5;
  color: #84888c;
}

.tf-sec-page__daev-label {
  display: block;
  margin: 0 0 8px;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
}

body.light_theme .tf-sec-page__daev-label {
  color: #101828;
}

.tf-sec-page__daev-inputWrap {
  position: relative;
  margin-bottom: 20px;
}

.tf-sec-page__daev-input {
  width: 100%;
  height: 48px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 0 100px 0 14px;
  font-size: 15px;
  font-weight: 500;
  color: #ffffff;
  background: #1e2329;
  outline: none;
}

.tf-sec-page__daev-input:focus {
  border-color: #d1aa67;
  box-shadow: 0 0 0 3px rgba(252, 213, 53, 0.15);
}

body.light_theme .tf-sec-page__daev-input {
  border: 1px solid #e5e7eb;
  color: #101828;
  background: #fff;
}

body.light_theme .tf-sec-page__daev-input:focus {
  border-color: #707070;
  box-shadow: 0 0 0 3px rgb(186 186 186 / 15%);
}

.tf-sec-page__daev-getCode {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  padding: 6px 4px;
  font-size: 14px;
  font-weight: 600;
  color: #d1aa67;
  cursor: pointer;
  transition: color 0.15s ease;
}

.tf-sec-page__daev-getCode:hover {
  color: #e0be2f;
}

body.light_theme .tf-sec-page__daev-getCode {
  color: #c9a063;
}

body.light_theme .tf-sec-page__daev-getCode:hover {
  color: #b08d52;
}

.tf-sec-page__daev-submit {
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 999px;
  background: #d1aa67;
  color: #0c0d10;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  margin-bottom: 16px;
  transition: background 0.15s ease;
}

.tf-sec-page__daev-submit:hover {
  background: #e0be2f;
}

.tf-sec-page__daev-submit:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

body.light_theme .tf-sec-page__daev-submit {
  background: #2b2b2b;
  color: #fff;
  font-weight: 500;
}

body.light_theme .tf-sec-page__daev-submit:hover {
  background: #1a1a1a;
}

body.light_theme .tf-sec-page__daev-submit:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.tf-sec-page__daev-help {
  display: block;
  width: 100%;
  border: none;
  background: transparent;
  padding: 0;
  margin: 7px 0 15px;
  font-size: 16px;
  letter-spacing: -0.40px;
  font-weight: 600;
  color: #d1aa67;
  cursor: pointer;
  text-align: center;
}


.gapbtn_space .tf-sec-page__daev-help {
  margin-bottom: 0px;
}

.gapbtn_space {
  margin-bottom: 20px;
}

body.light_theme .tf-sec-page__daev-help {
  color: #AC8A50;
}

.tf-sec-page__daev-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding-top: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin: 0px 0px;
  padding-left: 4px;
  padding-right: 4px;
  font-size: 14px;
  font-weight: 500;
  color: #84888C;
}

body.light_theme .tf-sec-page__daev-footer {
  border-top: 1px solid #f0f0f1;
  color: #6A7282;
}

.tf-sec-page__daev-footer img {
  width: 18px;
  height: 18px;
  display: block;
  object-fit: contain;
  flex-shrink: 0;
}


.security-verification-requirements .withdraw_sec_req_left img {
  filter: invert(0);
}

body.light_theme .security-verification-requirements .withdraw_sec_req_left img {
  filter: invert(1);
}

body.light_theme .withdraw_confirm_overlay .withdraw_sec_icon img {
  filter: invert(1);
}


@media (max-width: 1440px) {

  .tf-sec-page__hero-title {
    font-size: 36px;
  }

  .tf-sec-page {
    padding-right: 0px;
  }


}


@media (max-width: 1366px) {

  .tf-sec-page__hero-title {
    font-size: 32px;
  }

  .tf-sec-page {
    padding-right: 0px;
    padding-left: 20px;
  }


}

@media (max-width: 991px) {

  .tf-sec-page__hero-title {
    font-size: 30px;
  }

  .tf-sec-page__card-title {
    font-size: 16px;
  }

  .tf-sec-page__row-main {
    width: 60%;
    align-items: center;
  }

  .tf-sec-page {
    padding-left: 0px;
  }

  .tf-sec-page__row {
    padding: 20px 0px;
    border: none;
  }

  .tf-sec-page__hero {
    margin: 10px 0 10px;
  }


  .tf-sec-page__card {
    border: none;
    border-radius: 0px;
    margin-bottom: 24px;
    box-shadow: none;
    border-bottom: 1px solid #ededed26;
  }

  body.light_theme .tf-sec-page__card {
    border-bottom: 1px solid #ededed;
  }

  .tf-sec-page__card-header {
    padding: 9px 0px;
    border-bottom: none;
  }

  .tf-sec-page__row-description {
    display: none;
  }

  .tf-sec-page__row-heading {
    font-size: 16px;
    font-weight: 500;
  }

}


@media (max-width: 767px) {

  .tf-sec-page__hero-title {
    font-size: 24px;
  }

  .tf-sec-page {
    padding-left: 0px;
  }

  .tf-sec-page__hero {
    margin: 0px 0 10px;
    flex-wrap: nowrap;
    align-items: center;
  }

  .tf-sec-page__card {
    margin-bottom: 20px;
  }

  .tf-sec-page__l2sv-overlay,
  .tf-sec-page__wds-overlay,
  .tf-sec-page__daev-overlay {
    align-items: end;
    padding: 0px;
  }

  .tf-sec-page__daev-title {
    font-size: 20px;
  }

  .tf-sec-page__daev-modal {
    max-width: 100%;
    border-radius: 16px 16px 0px 0px;
  }

  .tf-sec-page__daev-submit {
    height: 42px;
    font-size: 14px;
  }

  .tf-sec-page__hero-description {
    display: none;
  }

  .tf-sec-page__hero-media {
    max-width: 100px;
  }

  .tf-sec-page__l2sv-modal {
    max-width: 100%;
    border-radius: 14px 14px 0px 0px;
  }

  .tf-sec-page__l2sv-title {
    font-size: 20px;
  }

  .tf-sec-page__l2sv-text {
    font-size: 15px;
  }

  .tf-sec-page__unbound-overlay {
    align-items: end;
  }

  .tf-sec-page__wds-text {
    font-size: 15px;
  }

  .tf-sec-page__wds-title {
    font-size: 20px;
  }

  .tf-sec-page__wds-modal {
    max-width: 100%;
    border-radius: 14px 14px 0px 0px;
    width: 100%;
  }

  .tf-sec-page__unbound-title {
    font-size: 20px;
  }

  .tf-sec-page__fundpw-title {
    font-size: 20px;
  }

  .tf-sec-page__fundpw-cta {
    height: 42px;
    font-size: 15px;
  }

  .tf-sec-page__fundpw-modal {
    max-width: 100%;
    border-radius: 16px 16px 0px 0px;
  }

  .tf-sec-page__unbound-modal {
    max-width: 100%;
    max-height: 70vh;
    overflow: auto;
    min-height: 35vh;
    border-radius: 16px 16px 0px 0px;
  }

  .tf-sec-page__unbound-cta {
    height: 42px;
    font-size: 14px;
  }

  .tf-sec-page__fundpw-overlay {
    align-items: end;
  }

  .tf-sec-page__fpw-confirm-modal {
    width: 100%;
    border-radius: 16px 16px 0px 0px;
  }

  .tf-sec-page__fpw-confirm-title {
    padding: 0 15px;
    font-size: 20px;
  }

  .tf-sec-page__fpw-confirm-art {
    width: 160px;
  }

  .tf-sec-page__fpw-confirm-cancel,
  .tf-sec-page__fpw-confirm-ok {
    min-height: 42px;
    font-size: 14px;
  }

  .tf-sec-page__row-icon-wrap {
    display: none;
  }

}


@media (max-width: 580px) {

  .tf-sec-page__hero-title {
    font-size: 20px;
  }


  .tf-sec-vault__card.is-live {
    box-shadow: inset 1px 0 0 #a4ebbe;
  }

  .tf-sec-page__row-main {
    width: 100%;
  }

  .tf-sec-page__btn {
    padding: 5px 1px;
    min-width: 70px;
    font-size: 12px;
  }

  .tf-sec-page__method-list .tf-sec-page__btn {
    padding: 10px 20px;
  }

  .tf-sec-page__row-heading {
    font-size: 14px;
  }

  .tf-sec-page__row-meta {
    min-width: auto;
  }

  .tf-sec-page__status {
    gap: 3px;
    font-size: 12px;
  }

  .tf_checkfill {
    font-size: 10px;
    width: 14px;
    height: 14px;
  }


}

/* ── Withdrawal settings inline verification step ── */
.tf-sec-page__wds-verify {
  padding: 16px 0 8px;
  border-top: 1px solid #f1f5f9;
}

.tf-sec-page__wds-verify-label {
  font-size: 13px;
  color: #374151;
  margin-bottom: 10px;
  line-height: 1.4;
}

.tf-sec-page__wds-verify-input {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.15s;
}

.tf-sec-page__wds-verify-input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);
}

.tf-sec-page__wds-verify-error {
  margin: 6px 0 0;
  font-size: 12px;
  color: #dc2626;
}

.tf-sec-page__wds-verify-actions {
  display: flex;
  gap: 10px;
  margin-top: 12px;
  justify-content: flex-end;
}

.tf-sec-page__wds-verify-btn {
  padding: 8px 18px;
  border-radius: 8px;
  border: none;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s, opacity 0.15s;
}

.tf-sec-page__wds-verify-btn--cancel {
  background: #f1f5f9;
  color: #374151;
}

.tf-sec-page__wds-verify-btn--cancel:hover {
  background: #e2e8f0;
}

.tf-sec-page__wds-verify-btn--confirm {
  background: #3b82f6;
  color: #fff;
}

.tf-sec-page__wds-verify-btn--confirm:hover {
  background: #2563eb;
}

.tf-sec-page__wds-verify-btn--confirm:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* —— Protection vault — premium client dashboard —— */
.tf-sec-vault {
  margin-bottom: 24px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

.tf-sec-vault__panel {
  position: relative;
  overflow: visible;
  border-radius: 16px;
  border: 1px solid #f3f4f60a;
  background: #181a20;
  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.22);
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

body.light_theme .tf-sec-vault__panel {
  border: 1px solid #f3f4f638;
}

.tf-sec-vault__panel::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  pointer-events: none;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.04);
}

body.light_theme .tf-sec-vault__panel::after {
  box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.04);
}

body.light_theme .tf-sec-vault__panel {
  border-color: #f3f4f6;
  background: linear-gradient(180deg, #ffffff 0%, #faf7f1 100%);
  box-shadow: 0 12px 36px rgba(15, 23, 42, 0.07);
}

.tf-sec-vault__accent {
  display: none;
}

/* Override global \`header { height: 60px }\` if a header tag is ever used here */
.tf-sec-vault__header {
  display: flex;
  align-items: center;
  gap: 14px;
  height: auto;
  padding: 14px 16px 12px;
  margin: 0;
  background: transparent;
  border-bottom: 1px solid #f3f4f60a;
}

body.light_theme .tf-sec-vault__header {
  border-bottom-color: #f3f4f6;
}

.tf-sec-vault__orb {
  --vault-progress: 0%;
  position: relative;
  width: 72px;
  height: 72px;
  border-radius: 50%;
  padding: 3px;
  flex-shrink: 0;
  background: conic-gradient(var(--tf-green, #00a870) var(--vault-progress), rgba(148, 163, 184, 0.2) 0);
}

.tf-sec-vault__orb-inner {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  background: linear-gradient(180deg, rgba(20, 24, 34, 1) 0%, rgba(12, 14, 20, 1) 100%);
  border: 1px solid rgba(255, 255, 255, 0.06);
}

body.light_theme .tf-sec-vault__orb-inner {
  background: linear-gradient(180deg, #ffffff 0%, #f8f4ec 100%);
  border-color: #f0e0c4;
}

.tf-sec-vault__orb-inner>i {
  font-size: 18px;
  color: var(--tf-green, #00a870);
}

.tf-sec-vault__orb-count {
  display: inline-flex;
  align-items: baseline;
  gap: 1px;
  line-height: 1;
}

.tf-sec-vault__orb-score {
  font-size: 18px;
  font-weight: 800;
  letter-spacing: -0.03em;
  color: #f8fafc;
}

body.light_theme .tf-sec-vault__orb-score {
  color: #0f172a;
}

.tf-sec-vault__orb-total {
  font-size: 12px;
  font-weight: 700;
  color: var(--tf-muted);
}

.tf-sec-vault__intro {
  flex: 1 1;
  min-width: 0;
}

.tf-sec-vault__kicker {
  margin: 0 0 2px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #d1aa67;
}

.tf-sec-vault__headline {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #f8fafc;
  line-height: 1.2;
}

body.light_theme .tf-sec-vault__headline {
  color: #101828;
}

.tf-sec-vault__subtitle {
  margin: 3px 0 0;
  font-size: 12px;
  line-height: 1.4;
  color: var(--tf-muted);
  max-width: 480px;
}

.tf-sec-vault__summary {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
  flex-shrink: 0;
}

.tf-sec-vault__coverage {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 7px 11px;
  border-radius: 10px;
  border: 1px solid #353a42;
  background: #1f2127;
  min-width: 80px;
  --vault-coverage: 0%;
}

.tf-sec-vault__coverage-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

body.light_theme .tf-sec-vault__coverage {
  background: #f0fdf4;
  border-color: #bbf7d0;
}

.tf-sec-vault__coverage-value {
  font-size: 20px;
  font-weight: 800;
  line-height: 1;
  letter-spacing: -0.03em;
  color: #4ade80;
}

body.light_theme .tf-sec-vault__coverage-value {
  color: #16a34a;
}

.tf-sec-vault__coverage-label {
  margin-top: 2px;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--tf-muted);
}

.tf-sec-vault__coverage-track {
  display: none;
}

.tf-sec-vault__coverage-fill {
  height: 100%;
  width: var(--vault-coverage);
  border-radius: inherit;
  background: linear-gradient(90deg, #16a34a 0%, #4ade80 100%);
}

.tf-sec-vault__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  padding: 10px 14px 12px;
}

.tf-sec-vault__card {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 10px 9px 12px;
  border-radius: 12px;
  background: #94a3b80f;
  border: 1px solid #94a3b80f;
  /* box-shadow: inset 3px 0 0 rgba(148, 163, 184, 0.35); */
}

button.tf-sec-vault__card--action {
  width: 100%;
  margin: 0;
  font: inherit;
  color: inherit;
  text-align: left;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  transition: border-color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
}

button.tf-sec-vault__card--action:hover {

  border-color: rgb(59 63 72);
  background: rgb(30 34 42);
  /* box-shadow: inset 3px 0 0 #353a42; */
}

button.tf-sec-vault__card--action:focus-visible {
  outline: 2px solid #d1aa67;
  outline-offset: 2px;
}

body.light_theme button.tf-sec-vault__card--action:hover {
  border-color: rgb(59 63 72 / 16%);
  background: rgb(242 243 247);
  /* box-shadow: inset 3px 0 0 #353a4240; */
}

body.light_theme .tf-sec-vault__card {
  background: #ffffff;
  border-color: #eef2f7;
  /* box-shadow: inset 3px 0 0 #e2e8f0; */
}

.tf-sec-vault__card.is-live {
  /* background: linear-gradient(135deg, rgba(34, 197, 94, 0.1) 0%, rgba(255, 255, 255, 0.02) 100%); */
  /* border-color: #a4ebbe6e;
  box-shadow: inset 3px 0 0 #a4ebbe85; */
}

/* body.light_theme .tf-sec-vault__card.is-live {
  background: linear-gradient(135deg, #f0fdf4 0%, #ffffff 100%);
  border-color: #bbf7d0;
  box-shadow: inset 3px 0 0 #bbf7d0;
} */

.tf-sec-vault__card-icon {
  width: 34px;
  height: 34px;
  border-radius: 9px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 17px;
  color: #94a3b8;
  background: rgba(148, 163, 184, 0.1);
  border: 1px solid rgba(148, 163, 184, 0.16);
}

body.light_theme .tf-sec-vault__card-icon {
  background: #f8fafc;
  border-color: #e8edf3;
}

.tf-sec-vault__card.is-live .tf-sec-vault__card-icon {
  color: #94a3b8;
  /* background: rgba(34, 197, 94, 0.14);
  border-color: rgba(34, 197, 94, 0.3); */
}

/* body.light_theme .tf-sec-vault__card.is-live .tf-sec-vault__card-icon {
  color: #16a34a;
  background: #dcfce7;
  border-color: #bbf7d0;
} */

.tf-sec-vault__card-body {
  min-width: 0;
  flex: 1 1;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 6px;
}

.tf-sec-vault__card-title {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: #e2e8f0;
  line-height: 1.2;
}

body.light_theme .tf-sec-vault__card-title {
  color: #1e293b;
}

.tf-sec-vault__card.is-live .tf-sec-vault__card-title {
  color: #dcfce7;
}

body.light_theme .tf-sec-vault__card.is-live .tf-sec-vault__card-title {
  color: #333333;
}

.tf-sec-vault__card-badge {
  display: inline-flex;
  margin-top: 0;
  padding: 1px 7px;
  border-radius: 999px;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #94a3b8;
  background: rgba(148, 163, 184, 0.12);
}

body.light_theme .tf-sec-vault__card-badge {
  color: #64748b;
  background: #f1f5f9;
}

.tf-sec-vault__card-badge.is-live {
  color: #94a3ac;
  background: rgb(41 45 50);
}

/* body.light_theme .tf-sec-vault__card-badge.is-live {
  color: #16a34a;
  background: #dcfce7;
} */

.tf-sec-vault__card-check {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 12px;
  color: #64748b;
  background: rgba(148, 163, 184, 0.12);
  border: 1px solid rgba(148, 163, 184, 0.18);
}

body.light_theme .tf-sec-vault__card-check {
  background: #f8fafc;
  border-color: #e2e8f0;
}

.tf-sec-vault__card-check.is-live {
  color: var(--tf-green, #00a870);
  background: transparent;
  border-color: var(--tf-green, #00a870);
}

.tf-sec-vault__card-check.is-live i {
  font-weight: 700;
}

@media (max-width: 1200px) {

  .tf-sec-page__row-meta {
    min-width: auto;
  }

  .tf-sec-page__row-actions {
    min-width: 150px;
  }

  .tf-sec-page__row {
    padding: 24px 32px 24px 24px;
  }

  .tf-sec-vault__header {
    flex-wrap: wrap;
  }

  .tf-sec-vault__summary {
    width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
  }

  .tf-sec-vault__coverage {
    flex-direction: row;
    align-items: center;
    gap: 8px;
    min-width: 0;
  }

  .tf-sec-vault__coverage-meta {
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }

  .tf-sec-vault__coverage-label {
    margin-top: 0;
  }
}


@media (max-width:991px) {

  .tf-sec-page__row {
    padding: 20px 0px 20px 0px;
  }

  .tf-sec-page__row-actions {
    min-width: 240px;
  }

}


/* —— Mobile: compact premium dashboard tiles —— */
@media (max-width: 767px) {


  .tf-sec-page__row-actions {
    min-width: 110px;
    max-width: 110px;
  }

  .tf-sec-page__card .tf-sec-page__row-meta {
    min-width: 100px;
    text-align: right;
  }

  .tf-sec-vault {
    margin-bottom: 16px;
  }

  .tf-sec-vault__panel {
    border-radius: 16px;
    box-shadow: 0 8px 28px rgba(15, 23, 42, 0.06);
  }

  body.light_theme .tf-sec-vault__panel {
    background: #ffffff;
  }

  .tf-sec-vault__header {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
    grid-template-areas:
      "orb intro"
      "coverage coverage";
    align-items: center;
    gap: 12px;
    padding: 16px 14px 14px;
  }

  .tf-sec-vault__orb {
    grid-area: orb;
    width: 68px;
    height: 68px;
  }

  .tf-sec-vault__orb-inner>i {
    font-size: 15px;
  }

  .tf-sec-vault__orb-score {
    font-size: 17px;
  }

  .tf-sec-vault__orb-total {
    font-size: 11px;
  }

  .tf-sec-vault__intro {
    grid-area: intro;
  }

  .tf-sec-vault__kicker {
    margin-bottom: 3px;
    font-size: 9px;
  }

  .tf-sec-vault__headline {
    font-size: 15px;
    line-height: 1.25;
  }

  .tf-sec-vault__subtitle {
    margin-top: 4px;
    font-size: 12px;
    line-height: 1.4;
    max-width: none;
  }

  .tf-sec-vault__summary {
    grid-area: coverage;
    width: 100%;
  }

  .tf-sec-vault__coverage {
    width: 100%;
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
    padding: 10px 12px;
    border-radius: 12px;
    min-width: 0;
  }

  .tf-sec-vault__coverage-meta {
    width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .tf-sec-vault__coverage-label {
    margin-top: 0;
    order: -1;
    font-size: 10px;
  }

  .tf-sec-vault__coverage-value {
    font-size: 18px;
  }

  .tf-sec-vault__coverage-track {
    display: block;
    width: 100%;
    height: 6px;
    border-radius: 999px;
    overflow: hidden;
    background: rgba(148, 163, 184, 0.2);
  }

  body.light_theme .tf-sec-vault__coverage-track {
    background: #dcfce7;
  }

  .tf-sec-vault__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 5px;
    padding: 6px 8px 8px;
  }

  .tf-sec-vault__card {
    position: relative;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    gap: 3px;
    min-height: 0;
    min-width: 0;
    padding: 5px 8px;
    border-radius: 8px;
    box-shadow: none;
  }

  body.light_theme .tf-sec-vault__card {
    box-shadow: none;
  }

  body.light_theme .tf-sec-vault__card.is-live {
    box-shadow: none;
  }

  .tf-sec-vault__card-icon {
    width: 20px;
    height: 20px;
    font-size: 11px;
    border-radius: 6px;
  }

  .tf-sec-vault__card-check {
    position: absolute;
    top: 4px;
    right: 4px;
    width: 14px;
    height: 14px;
    font-size: 8px;
  }

  .tf-sec-vault__card-body {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    padding-right: 2px;
  }

  .tf-sec-vault__card-title {
    font-size: 10px;
    font-weight: 700;
    line-height: 1.1;
    word-break: break-word;
  }

  .tf-sec-vault__card-badge {
    padding: 0 4px;
    font-size: 6px;
    letter-spacing: 0.02em;
  }

  .tf-sec-page__status-email {
    font-size: 12px;
    word-break: break-all;
  }
}

@media (max-width: 480px) {

  .tf-sec-page__l2sv-row-icons {
    display: none;
  }

  .tf-sec-page__row-heading-line {
    gap: 0px;
  }

  .tf-sec-page__badge {
    font-size: 10px;
  }

  .tf-sec-page__row-actions {
    min-width: 90px;
    max-width: 90px;
  }

}

@media (max-width: 380px) {

  .tf-sec-page__row {
    align-items: center;
  }


  .tf-sec-vault__header {
    padding: 14px 12px 12px;
    gap: 10px;
  }

  .tf-sec-vault__orb {
    width: 60px;
    height: 60px;
  }

  .tf-sec-vault__headline {
    font-size: 14px;
  }

  .tf-sec-page__status-email {
    font-size: 12px;
  }

  .tf-sec-vault__subtitle {
    font-size: 11px;
  }

  .tf-sec-vault__grid {
    gap: 4px;
    padding: 5px 6px 6px;
  }

  .tf-sec-vault__card {
    gap: 2px;
    border-radius: 7px;
  }

  .tf-sec-vault__card-icon {
    width: 18px;
    height: 18px;
    font-size: 10px;
  }

  .tf-sec-vault__card-check {
    width: 12px;
    height: 12px;
    font-size: 7px;
    top: 3px;
    right: 3px;
  }

  .tf-sec-vault__card-title {
    font-size: 9px;
  }

  .tf-sec-vault__card-badge {
    padding: 0 3px;
    font-size: 6px;
  }
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/TwofactorPage/security.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,wBAAwB;EACxB,oBAAoB;EACpB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;;AAEtB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;;EAEd,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,iEAAiE;AACjE;EACE,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,6EAA6E;AAC7E;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA,kFAAkF;AAClF;;EAEE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,gEAAgE;AAChE;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,0DAA0D;EAC1D,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE;4BAC0B;EAC1B,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ;2BACyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE;IACE,0BAA0B;IAC1B,mBAAmB;IACnB,SAAS;EACX;;EAEA;;IAEE,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC,oCAAoC;AACpC;;;EAGE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;;;EAGE,kCAAkC;EAClC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,8DAA8D;AAC9D;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,2EAA2E;AAC3E;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;EAC1B,kCAAkC;EAClC,uCAAuC;EACvC,2CAA2C;EAC3C,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,2CAA2C;EAC3C,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,QAAQ;EACR,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,0BAA0B;EAC1B,kCAAkC;EAClC,qBAAqB;EACrB,0CAA0C;EAC1C,2CAA2C;EAC3C,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,8DAA8D;AAC9D;EACE,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;EAC1B,kCAAkC;EAClC,qBAAqB;EACrB,0CAA0C;EAC1C,2CAA2C;EAC3C,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA;;EAEE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,0BAA0B;EAC1B,kCAAkC;EAClC,uCAAuC;EACvC,2CAA2C;EAC3C,uBAAuB;EACvB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,8BAA8B;AAC9B;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,0BAA0B;EAC1B,kCAAkC;EAClC,qBAAqB;EACrB,0CAA0C;EAC1C,2CAA2C;EAC3C,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA,+CAA+C;AAC/C;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,0BAA0B;EAC1B,kCAAkC;EAClC,qBAAqB;EACrB,0CAA0C;EAC1C,2CAA2C;EAC3C,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,8CAA8C;EAC9C,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;;AAGA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;;AAGA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;;AAGF;;;AAGA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;;AAGF;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;;EAGA;IACE,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,kCAAkC;EACpC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;AAEF;;;AAGA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;;IAGE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gCAAgC;IAChC,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;AAEF;;;AAGA;;EAEE;IACE,eAAe;EACjB;;;EAGA;IACE,iCAAiC;EACnC;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;EACd;;;AAGF;;AAEA,uDAAuD;AACvD;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,2CAA2C;EAC3C,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,oBAAoB;EACpB,qDAAqD;AACvD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,qBAAqB;EACrB,6DAA6D;EAC7D,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,sGAAsG;AACxG;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,qFAAqF;EACrF,2CAA2C;AAC7C;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,sBAAsB;EACtB,4DAA4D;AAC9D;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,yDAAyD;AAC3D;;AAEA;EACE,WAAW;EACX,SAAS;EACT,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,8EAA8E;AAChF;;AAEA;;EAEE,2BAA2B;EAC3B,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,4BAA4B;EAC5B,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,oGAAoG;EACpG;wCACsC;AACxC;;AAEA;;;;GAIG;;AAEH;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd;yCACuC;AACzC;;AAEA;;;;GAIG;;AAEH;EACE,YAAY;EACZ,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;;GAGG;;AAEH;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;AACF;;;AAGA;;EAEE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;AAEF;;;AAGA,kDAAkD;AAClD;;;EAGE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,6CAA6C;EAC/C;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,0CAA0C;IAC1C;;yBAEqB;IACrB,mBAAmB;IACnB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,WAAW;IACX,oBAAoB;IACpB,gBAAgB;IAChB,oCAAoC;EACtC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gDAAgD;IAChD,QAAQ;IACR,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,QAAQ;IACR,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,cAAc;IACd,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;AACF;;AAEA;;EAEE;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;AAEF;;AAEA;;EAEE;IACE,mBAAmB;EACrB;;;EAGA;IACE,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,oBAAoB;EACtB;;EAEA;IACE,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;IACd,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,cAAc;EAChB;AACF","sourcesContent":["/**\n * Security Settings (two_factor_autentication) — all rules scoped under .tf-sec-page (BEM: tf-sec-page__*).\n */\n\n.tf-sec-page {\n  --tf-bg: #f4f6f8;\n  --tf-card: #ffffff;\n  --tf-border: #F3F4F6;\n  --tf-text: #101828;\n  --tf-muted: #9ca3af;\n  --tf-muted2: #94a3b8;\n  --tf-green: #00a870;\n  --tf-badge-bg: #fff4e6;\n  --tf-badge-text: #c27803;\n  --tf-btn-bg: #f1f5f9;\n  --tf-btn-text: #1e293b;\n  --tf-radius: 16px;\n  --tf-radius-sm: 6px;\n  box-sizing: border-box;\n  width: 100%;\n  min-height: 100%;\n  padding-left: 40px;\n  padding-right: 167px;\n\n}\n\n.tf-sec-page *,\n.tf-sec-page *::before,\n.tf-sec-page *::after {\n  box-sizing: border-box;\n}\n\n/* Hero (div.tf-sec-page__hero — no <header>) */\n.tf-sec-page__hero {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 24px;\n  margin: 36px 0 10px;\n  flex-wrap: wrap;\n}\n\n.tf-sec-page__hero-content {\n  flex: 1 1 280px;\n  min-width: 0;\n}\n\n.tf-sec-page__hero-title {\n  margin: 0 0 12px;\n  font-size: 40px;\n  font-weight: 600;\n  letter-spacing: -0.03em;\n  color: #ebebeb;\n  line-height: 1.2;\n}\n\nbody.light_theme .tf-sec-page__hero-title {\n  color: #101828;\n}\n\n.tf-sec-page__hero-description {\n  margin: 20px 0 0;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.55;\n  color: var(--tf-muted);\n  max-width: 760px;\n}\n\n.tf-sec-page__hero-media {\n  flex: 0 0 auto;\n  width: min(200px, 42vw);\n  max-width: 220px;\n}\n\n.tf-sec-page__hero-media img {\n  display: block;\n  width: 100%;\n  height: auto;\n}\n\n/* Card */\n.tf-sec-page__card {\n  background: none;\n  border: 1px solid #f3f4f60a;\n  border-radius: var(--tf-radius);\n  margin-bottom: 40px;\n  overflow: hidden;\n  box-shadow: 0px 1px 3px #00000010;\n}\n\nbody.light_theme .tf-sec-page__card {\n  background: #ffffff;\n  border: 1px solid #f3f4f630;\n}\n\n/* Card top block (div.tf-sec-page__card-header — no <header>) */\n.tf-sec-page__card-header {\n  padding: 24px;\n  border-bottom: 1px solid #f3f4f60a;\n}\n\nbody.light_theme .tf-sec-page__card-header {\n  border-bottom: 1px solid #f3f4f636;\n}\n\n.tf-sec-page__card-title {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n  color: #f8f8f8;\n\n  letter-spacing: -0.02em;\n}\n\nbody.light_theme .tf-sec-page__card-title {\n  color: #101828;\n}\n\n.tf-sec-page__card-subtitle {\n  margin: 8px 0 0;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 1.5;\n  color: var(--tf-muted);\n}\n\n.tf-sec-page__card-body {\n  padding: 0 0 8px;\n}\n\n/* Row */\n.tf-sec-page__row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px 16px;\n  padding: 24px 70px 24px 24px;\n  border-top: 1px solid #f3f4f60a;\n}\n\nbody.light_theme .tf-sec-page__row {\n  border-top: 1px solid #f3f4f638;\n}\n\n\n.tf-sec-page__card-body .tf-sec-page__row:first-of-type {\n  border-top: none;\n}\n\n.tf-sec-page__row-main {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  min-width: 0;\n  width: 710px;\n  max-width: 100%;\n}\n\n.tf-sec-page__row-icon-wrap {\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.tf-sec-page__row-icon {\n  width: 36px;\n  height: 36px;\n  object-fit: contain;\n}\n\n.tf-sec-page__row-body {\n  min-width: 0;\n}\n\n.tf-sec-page__card .email_verify {\n  margin-right: 22px;\n}\n\n.tf-sec-page__row-heading-line {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 4px;\n}\n\n.tf-sec-page__row-heading {\n  font-size: 18px;\n  font-weight: 600;\n  color: #eeeeee;\n}\n\nbody.light_theme .tf-sec-page__row-heading {\n  color: #101828;\n}\n\n.tf-sec-page__badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 5px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 500;\n  background: #FBF1DF00;\n  color: #D1AA67;\n  line-height: 1.3;\n}\n\nbody.light_theme .tf-sec-page__badge {\n  background: #FBF1DF;\n  color: #D1AA67;\n}\n\n.tf-sec-page__row-description {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.45;\n  font-weight: 400;\n  color: #cacaca;\n}\n\nbody.light_theme .tf-sec-page__row-description {\n  color: #4A5565;\n}\n\n.tf_checkfill {\n  background-color: rgb(195 197 199 / 20%);\n  color: #fff;\n  width: 20px;\n  font-weight: 600;\n  height: 20px;\n  border-radius: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nbody.light_theme .tf_checkfill {\n  background-color: rgb(195 197 199 / 40%);\n  color: #242424;\n}\n\n.tf-sec-page__row-meta {\n  justify-self: end;\n  min-width: 142px;\n  text-align: right;\n}\n\n.tf-sec-page__status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 14px;\n  color: #4A5565;\n  font-weight: 500;\n}\n\n/* Read-only status (no toggle) — gray pill + check + OFF label */\n.tf-sec-page__status--readonly-off {\n  gap: 8px;\n}\n\n.tf-sec-page__status--readonly-off .tf-sec-page__status-dot {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: #9ca3af;\n  color: #fff;\n  flex-shrink: 0;\n}\n\n.tf-sec-page__status--readonly-off .tf-sec-page__status-dot i {\n  font-size: 12px;\n  line-height: 1;\n}\n\n.tf-sec-page__status--readonly-off .tf-sec-page__status-label {\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  color: #6b7280;\n  text-transform: none;\n}\n\n.tf-sec-page__status--success {\n  color: var(--tf-green, #00a870);\n}\n\n.tf-sec-page__status--success .tf_checkfill {\n  background-color: var(--tf-green, #00a870);\n  color: #fff;\n}\n\n.tf-sec-page__status--success>span {\n  color: var(--tf-green, #00a870);\n  font-weight: 600;\n}\n\n.tf-sec-page__status-email--success {\n  color: #f5f5f5;\n  font-weight: 600;\n}\n\nbody.light_theme .tf-sec-page__status-email {\n  color: #4A5565;\n}\n\n.tf-sec-page__l2sv-row-icons {\n  display: inline-flex;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 6px;\n  max-width: 220px;\n  margin-right: 4px;\n}\n\n/* One chip per method — same size as email so GA / SMS are equally visible */\n.tf-sec-page__l2sv-method {\n  display: inline-flex;\n  width: 28px;\n  height: 28px;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n}\n\n.tf-sec-page__l2sv-method img {\n  width: 18px;\n  height: 18px;\n  object-fit: contain;\n  display: block;\n}\n\n.tf-sec-page__l2sv-row-icon {\n  display: inline-flex;\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n}\n\n.tf-sec-page__l2sv-row-icon img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n}\n\n/* Stack with row icons: avoid 22px margin from .tf-sec-page__card .email_verify */\n.tf-sec-page__card .tf-sec-page__l2sv-row-icons .email_verify,\n.tf-sec-page__l2sv-row-icons .email_verify {\n  margin-right: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.tf-sec-page__fund-pw-status--on {\n  color: var(--tf-green, #00a870);\n  font-weight: 600;\n}\n\n/* Login password row — neutral “on” label (not success green) */\n.tf-sec-page__status--login-password {\n  color: #615565;\n}\n\n.tf-sec-page__login-password-status {\n  color: #615565;\n  font-weight: 600;\n}\n\n.tf-sec-page__status-indicator {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #cbd5e1;\n  flex-shrink: 0;\n}\n\n.tf-sec-page__status-email {\n  font-weight: 500;\n  font-size: 14px;\n  color: #e3e3e3;\n}\n\nbody.light_theme .tf-sec-page__status-email {\n  color: #4A5565;\n}\n\n.tf-sec-page__google-badge {\n  display: inline-flex;\n  align-items: center;\n  background-color: #E9E9E9;\n  justify-content: center;\n  vertical-align: middle;\n  width: 24px;\n  height: 24px;\n  border-radius: 50px;\n  padding: 3px;\n}\n\n.tf-sec-page__google-badge svg {\n  display: block;\n}\n\n.tf-sec-page__row-actions {\n  justify-self: end;\n  min-width: 200px;\n  justify-content: end;\n  display: flex;\n}\n\n.tf-sec-page__row-actions--split {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.tf-sec-page__btn--compact {\n  min-width: auto;\n  padding: 8px 14px;\n  flex-shrink: 0;\n}\n\n.tf-sec-page__aph-remove-field {\n  width: 100%;\n  margin-bottom: 14px;\n}\n\n.tf-sec-page__aph-remove-label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--tf-text, #1e293b);\n  margin-bottom: 6px;\n}\n\n.tf-sec-page__aph-remove-input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 10px 12px;\n  font-size: 14px;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  background: #fff;\n  color: var(--tf-text, #1e293b);\n}\n\n.tf-sec-page__aph-remove-row {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.tf-sec-page__aph-remove-row .tf-sec-page__aph-remove-input {\n  flex: 1;\n  min-width: 0;\n}\n\n.tf-sec-page__method-list {\n  flex-direction: column;\n  display: flex;\n  gap: 12px;\n  margin: 20px 0px 10px;\n  text-align: left;\n}\n\n.tf-sec-page__method-list .tf-sec-page__btn {\n  display: block;\n  width: 100%;\n  margin-bottom: 8px;\n  text-align: left;\n  opacity: 0.85;\n}\n\n.tf-sec-page__method-list .tf-sec-page__btn.active {\n  opacity: 1;\n  border: 1px solid currentColor;\n}\n\n.tf-sec-page__method-list .tf-sec-page__btn-desc {\n  font-size: 12px;\n  font-weight: 400;\n  opacity: 0.8;\n}\n\n.tf-sec-page__btn {\n  appearance: none;\n  margin: 0;\n  padding: 12px 24px;\n  min-width: 88px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #ffffff;\n  background: #2b313d52;\n  border: 1px solid #44444454;\n  border-radius: 50px;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n  white-space: nowrap;\n}\n\nbody.light_theme .tf-sec-page__btn {\n  color: var(--tf-btn-text);\n  background: #EFF1F5;\n  border: 1px solid #eff1f5;\n}\n\n.tf-sec-page__btn:hover:not(:disabled) {\n  opacity: 0.8;\n}\n\n.tf-sec-page__btn:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.tf-sec-page__btn--danger {\n\n  /* background: #fff;\n    border-color: #fecaca; */\n  color: #ffffff;\n}\n\n.tf-sec-page__btn--danger:hover:not(:disabled) {\n  opacity: 0.8;\n  /* background: #fef2f2;\n  border-color: #ffffff;  */\n}\n\n.tf-sec-page__btn--dark {\n  color: #fff;\n  background: #1e293b;\n  border-color: #1e293b;\n}\n\n.tf-sec-page__btn--dark:hover:not(:disabled) {\n  background: #334155;\n  border-color: #334155;\n}\n\n@media (max-width: 720px) {\n  .tf-sec-page__row {\n    grid-template-columns: 1fr;\n    align-items: center;\n    gap: 12px;\n  }\n\n  .tf-sec-page__row-meta,\n  .tf-sec-page__row-actions {\n    justify-self: stretch;\n    text-align: left;\n  }\n\n  .tf-sec-page__row-actions .tf-sec-page__btn {\n    width: 100%;\n  }\n\n  .tf-sec-page__hero-media {\n    margin: 0 auto;\n  }\n}\n\nbody.light_theme .tf-sec-page {\n  --tf-bg: #f4f6f8;\n}\n\n/* Login 2-Step Verification modal */\n/* Login 2-Step Verification modal */\n.tf-sec-page__l2sv-overlay,\n.tf-sec-page__wds-overlay,\n.tf-sec-page__daev-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 18px;\n  z-index: 100000020;\n}\n\nbody.light_theme .tf-sec-page__l2sv-overlay,\nbody.light_theme .tf-sec-page__wds-overlay,\nbody.light_theme .tf-sec-page__daev-overlay {\n  background: rgb(255 255 255 / 20%);\n  /* border: 1px solid #E1E1E1; */\n  box-shadow: none;\n}\n\n.tf-sec-page__daev-overlay {\n  z-index: 100000021;\n}\n\n/* Phone unbound modal (opened from SMS verification toggle) */\n.tf-sec-page__unbound-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0px;\n  z-index: 100000025;\n}\n\nbody.light_theme .tf-sec-page__unbound-overlay {\n  background: rgb(255 255 255 / 20%);\n}\n\n/* Portaled to document.body — escapes profile column / overflow stacking */\n.tf-sec-page__unbound-overlay--portal {\n  z-index: 2147483000;\n}\n\n.tf-sec-page__unbound-modal {\n  width: 520px;\n  max-width: 92vw;\n  border-radius: 20px;\n  background: #1e202670;\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  border: 1px solid rgb(255 255 255 / 8%);\n  box-shadow: 0 24px 56px rgba(0, 0, 0, 0.50);\n  padding: 26px 24px 22px;\n  position: relative;\n  text-align: left;\n}\n\nbody.light_theme .tf-sec-page__unbound-modal {\n  background: rgb(255 255 255 / 20%);\n  border: 1px solid #e8eaed;\n  box-shadow: 0 24px 56px rgba(15, 23, 42, 0.18);\n}\n\n.tf-sec-page__unbound-close {\n  position: absolute;\n  top: 12px;\n  right: 14px;\n  width: 34px;\n  height: 34px;\n  border: none;\n  background: transparent;\n  color: #84888C;\n  font-size: 22px;\n  line-height: 1;\n  cursor: pointer;\n  border-radius: 10px;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.tf-sec-page__unbound-close:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #fff;\n}\n\nbody.light_theme .tf-sec-page__unbound-close {\n  color: #111827;\n}\n\nbody.light_theme .tf-sec-page__unbound-close:hover {\n  background: rgba(17, 24, 39, 0.06);\n  color: #111827;\n}\n\n.tf-sec-page__unbound-title {\n  margin: 2px 0 12px;\n  padding-right: 44px;\n  font-size: 22px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: #ffffff;\n}\n\nbody.light_theme .tf-sec-page__unbound-title {\n  color: #0b0f1a;\n}\n\n.tf-sec-page__unbound-subtitle {\n  margin: 0 0 22px;\n  font-size: 15px;\n  line-height: 1.5;\n  font-weight: 400;\n  color: #84888C;\n  max-width: 440px;\n}\n\nbody.light_theme .tf-sec-page__unbound-subtitle {\n  color: #111827;\n}\n\n.tf-sec-page__unbound-cta {\n  width: 100%;\n  height: 48px;\n  border: none;\n  border-radius: 999px;\n  background: #d1aa67;\n  color: #0c0d10;\n  font-size: 15px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.tf-sec-page__unbound-cta:hover {\n  background: #b99556;\n}\n\nbody.light_theme .tf-sec-page__unbound-cta {\n  background: #2d2e32;\n  color: #ffffff;\n  font-weight: 500;\n}\n\nbody.light_theme .tf-sec-page__unbound-cta:hover {\n  background: #1a1b1e;\n}\n\n/* Bind AGCX Authenticator modal */\n.tf-sec-page__bindauth-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.7);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 100000026;\n}\n\nbody.light_theme .tf-sec-page__bindauth-overlay {\n  background: transparent;\n}\n\n.tf-sec-page__bindauth-modal {\n  width: 520px;\n  max-width: 92vw;\n  border-radius: 16px;\n  background: #181a20;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 28px 60px rgba(0, 0, 0, 0.50);\n  padding: 22px 24px 20px;\n  position: relative;\n}\n\nbody.light_theme .tf-sec-page__bindauth-modal {\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  box-shadow: 0 28px 60px rgba(15, 23, 42, 0.24);\n}\n\n.tf-sec-page__bindauth-close {\n  position: absolute;\n  top: 12px;\n  right: 14px;\n  width: 34px;\n  height: 34px;\n  border: none;\n  background: transparent;\n  color: #84888C;\n  font-size: 22px;\n  line-height: 1;\n  cursor: pointer;\n  border-radius: 10px;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.tf-sec-page__bindauth-close:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #fff;\n}\n\nbody.light_theme .tf-sec-page__bindauth-close {\n  color: #111827;\n}\n\nbody.light_theme .tf-sec-page__bindauth-close:hover {\n  background: rgba(17, 24, 39, 0.06);\n  color: #111827;\n}\n\n.tf-sec-page__bindauth-title {\n  margin: 2px 0 10px;\n  padding-right: 44px;\n  font-size: 22px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: #ffffff;\n}\n\nbody.light_theme .tf-sec-page__bindauth-title {\n  color: #0b0f1a;\n}\n\n.tf-sec-page__bindauth-subtitle {\n  margin: 0 0 18px;\n  font-size: 14px;\n  line-height: 1.55;\n  color: #84888C;\n  max-width: 460px;\n}\n\nbody.light_theme .tf-sec-page__bindauth-subtitle {\n  color: #4b5563;\n}\n\n.tf-sec-page__bindauth-cta {\n  width: 100%;\n  height: 48px;\n  border: none;\n  border-radius: 999px;\n  background: #d1aa67;\n  color: #0c0d10;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.tf-sec-page__bindauth-cta:hover {\n  background: #e0be2f;\n}\n\nbody.light_theme .tf-sec-page__bindauth-cta {\n  background: #2d2e32;\n  color: #ffffff;\n  font-weight: 600;\n}\n\nbody.light_theme .tf-sec-page__bindauth-cta:hover {\n  background: #1a1b1e;\n}\n\n/* Fund password missing modal */\n.tf-sec-page__fundpw-overlay {\n  position: fixed;\n  inset: 0;\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  display: flex;\n  align-items: center;\n  background-color: rgba(0, 0, 0, 0.6);\n  justify-content: center;\n  z-index: 100000027;\n}\n\nbody.light_theme .tf-sec-page__fundpw-overlay {\n  background-color: rgb(255 255 255 / 20%);\n}\n\n.tf-sec-page__fundpw-modal {\n  width: 520px;\n  max-width: 92vw;\n  border-radius: 16px;\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  background: #1e202670;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.50);\n  padding: 22px 24px 20px;\n  position: relative;\n}\n\nbody.light_theme .tf-sec-page__fundpw-modal {\n  background: rgb(255 255 255 / 20%);\n  border: 1px solid #e5e7eb;\n  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.24);\n}\n\n.tf-sec-page__fundpw-close {\n  position: absolute;\n  top: 12px;\n  right: 14px;\n  width: 34px;\n  height: 34px;\n  border: none;\n  background: transparent;\n  color: #84888C;\n  font-size: 22px;\n  line-height: 1;\n  cursor: pointer;\n  border-radius: 10px;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.tf-sec-page__fundpw-close:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #fff;\n}\n\nbody.light_theme .tf-sec-page__fundpw-close {\n  color: #111827;\n}\n\nbody.light_theme .tf-sec-page__fundpw-close:hover {\n  background: rgba(17, 24, 39, 0.06);\n  color: #111827;\n}\n\n.tf-sec-page__fundpw-title {\n  margin: 2px 0 10px;\n  padding-right: 44px;\n  font-size: 22px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: #ffffff;\n}\n\nbody.light_theme .tf-sec-page__fundpw-title {\n  color: #0b0f1a;\n}\n\n.tf-sec-page__fundpw-subtitle {\n  margin: 0 0 18px;\n  font-size: 14px;\n  line-height: 1.55;\n  color: #84888C;\n  max-width: 460px;\n}\n\nbody.light_theme .tf-sec-page__fundpw-subtitle {\n  color: #4b5563;\n}\n\n.tf-sec-page__fundpw-cta {\n  width: 100%;\n  height: 48px;\n  border: none;\n  border-radius: 999px;\n  background: #d1aa67;\n  color: #0c0d10;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.tf-sec-page__fundpw-cta:hover {\n  background: #e0be2f;\n}\n\nbody.light_theme .tf-sec-page__fundpw-cta {\n  background: #2d2e32;\n  color: #ffffff;\n  font-weight: 600;\n}\n\nbody.light_theme .tf-sec-page__fundpw-cta:hover {\n  background: #1a1b1e;\n}\n\n/* Fund password — pre-navigation confirm (24h lock warning) */\n.tf-sec-page__fpw-confirm-modal {\n  width: min(560px, 92vw);\n  border-radius: 28px;\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  background: #1e202670;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 28px 60px rgba(0, 0, 0, 0.50);\n  padding: 28px 28px 24px;\n  position: relative;\n  text-align: center;\n}\n\nbody.light_theme .tf-sec-page__fpw-confirm-modal {\n  background: rgb(255 255 255 / 20%);\n  border: 1px solid #e5e7eb;\n  box-shadow: 0 28px 60px rgba(15, 23, 42, 0.24);\n}\n\n.tf-sec-page__fpw-confirm-close {\n  position: absolute;\n  top: 12px;\n  right: 14px;\n  width: 34px;\n  height: 34px;\n  border: none;\n  background: transparent;\n  color: #84888C;\n  font-size: 22px;\n  line-height: 1;\n  cursor: pointer;\n  border-radius: 10px;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.tf-sec-page__fpw-confirm-close:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #fff;\n}\n\nbody.light_theme .tf-sec-page__fpw-confirm-close {\n  color: #111827;\n}\n\nbody.light_theme .tf-sec-page__fpw-confirm-close:hover {\n  background: rgba(17, 24, 39, 0.06);\n  color: #111827;\n}\n\n.tf-sec-page__fpw-confirm-art {\n  position: relative;\n  width: 200px;\n  /* height: 132px; */\n  margin: 0 auto 8px;\n}\n\n.tf-sec-page__fpw-confirm-badge {\n  position: absolute;\n  border-radius: 50%;\n  z-index: 0;\n}\n\n.tf-sec-page__fpw-confirm-badge--lime {\n  width: 46px;\n  height: 46px;\n  background: #bef264;\n  top: 6px;\n  right: 10px;\n}\n\n.tf-sec-page__fpw-confirm-badge--blue {\n  width: 38px;\n  height: 38px;\n  background: #2563eb;\n  bottom: 14px;\n  left: 6px;\n}\n\n.tf-sec-page__fpw-confirm-shield {\n  position: relative;\n  z-index: 1;\n  display: block;\n  width: 100%;\n  height: auto;\n  margin: 22px auto 0;\n}\n\n.tf-sec-page__fpw-confirm-title {\n  margin: 15px 0 12px;\n  padding: 0 36px;\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: -0.45px;\n  line-height: 1.35;\n  color: #ffffff;\n}\n\n.passkey-modal-overlay.disable_ga_overlay .passkey-modal {\n  width: 540px;\n}\n\nbody.light_theme .tf-sec-page__fpw-confirm-title {\n  color: #0b0f1a;\n}\n\n.withdraw_sec_req_modal.sec-req-invert-icons.security-verification-requirements.dark_theme_white_icons_popup .withdraw_sec_req_left img {\n  filter: brightness(0) invert(0);\n}\n\nbody.light_theme .withdraw_sec_req_modal.sec-req-invert-icons.security-verification-requirements.dark_theme_white_icons_popup .withdraw_sec_req_left img {\n  filter: brightness(0) invert(1);\n}\n\n.tf-sec-page__fpw-confirm-body {\n  margin: 0 auto 22px;\n  max-width: 450px;\n  font-size: 14px;\n  /* font-weight: 500; */\n  line-height: 1.55;\n  color: #84888C;\n}\n\nbody.light_theme .tf-sec-page__fpw-confirm-body {\n  color: #6b7280;\n}\n\n.tf-sec-page__fpw-confirm-hours {\n  font-weight: 700;\n  color: #ea580c;\n}\n\n.tf-sec-page__fpw-confirm-actions {\n  display: flex;\n  gap: 12px;\n  align-items: stretch;\n}\n\n.tf-sec-page__fpw-confirm-cancel,\n.tf-sec-page__fpw-confirm-ok {\n  flex: 1;\n  min-height: 48px;\n  border: none;\n  border-radius: 999px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.tf-sec-page__fpw-confirm-cancel {\n  max-width: 150px;\n  background: #2b3139;\n  color: #eaecef;\n}\n\n.tf-sec-page__fpw-confirm-cancel:hover {\n  background: #3a414b;\n}\n\nbody.light_theme .tf-sec-page__fpw-confirm-cancel {\n  background: #e8eaed;\n  color: #111827;\n}\n\nbody.light_theme .tf-sec-page__fpw-confirm-cancel:hover {\n  background: #dce0e6;\n}\n\n.tf-sec-page__fpw-confirm-ok {\n  background: #d1aa67;\n  color: #0c0d10;\n}\n\n.tf-sec-page__fpw-confirm-ok:hover {\n  background: #c59f5e;\n}\n\nbody.light_theme .tf-sec-page__fpw-confirm-ok {\n  background: #2d2e32;\n  color: #ffffff;\n}\n\nbody.light_theme .tf-sec-page__fpw-confirm-ok:hover {\n  background: #1a1b1e;\n}\n\n/* Login 2-Step Verification modal */\n.tf-sec-page__l2sv-modal {\n  width: 628px;\n  max-width: 92vw;\n  border-radius: 14px;\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  border: 1px solid rgb(255 255 255 / 6%);\n  box-shadow: 0 28px 60px rgba(0, 0, 0, 0.50);\n  padding: 24px 24px 40px;\n  position: relative;\n  background-color: #1e202670;\n}\n\nbody.light_theme .tf-sec-page__l2sv-modal {\n  background-color: rgb(255 255 255 / 20%);\n  border: 1px solid #E1E1E1;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18);\n}\n\n.tf-sec-page__l2sv-close {\n  position: absolute;\n  top: 12px;\n  right: 14px;\n  width: 34px;\n  height: 34px;\n  border: none;\n  background: transparent;\n  color: #84888C;\n  font-size: 22px;\n  line-height: 1;\n  cursor: pointer;\n  border-radius: 10px;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.tf-sec-page__l2sv-close:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #fff;\n}\n\nbody.light_theme .tf-sec-page__l2sv-close {\n  color: #111827;\n}\n\nbody.light_theme .tf-sec-page__l2sv-close:hover {\n  background: rgba(17, 24, 39, 0.06);\n  color: #111827;\n}\n\n.tf-sec-page__l2sv-title {\n  margin: 2px 0 6px;\n  padding-right: 44px;\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: #ffffff;\n}\n\nbody.light_theme .tf-sec-page__l2sv-title {\n  color: #070808;\n}\n\n.tf-sec-page__l2sv-subtitle {\n  margin: 0 0 14px;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.45;\n  color: #84888C;\n  max-width: 420px;\n}\n\nbody.light_theme .tf-sec-page__l2sv-subtitle {\n  color: #84888c;\n}\n\n.tf-sec-page__l2sv-list {\n  margin-top: 10px;\n}\n\n.tf-sec-page__l2sv-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  padding: 18px 4px;\n}\n\n.tf-sec-page__l2sv-left {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.tf-sec-page__l2sv-icon {\n  width: 18px;\n  height: 18px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #ffffff;\n  flex: 0 0 auto;\n}\n\nbody.light_theme .tf-sec-page__l2sv-icon {\n  color: #111827;\n}\n\n.tf-sec-page__l2sv-icon img {\n  width: 18px;\n  height: 18px;\n  display: block;\n  object-fit: contain;\n  filter: invert(1);\n}\n\nbody.light_theme .tf-sec-page__l2sv-icon img {\n  filter: invert(0);\n}\n\n.tf-sec-page__l2sv-text {\n  font-size: 18px;\n  font-weight: 600;\n  color: #ffffff;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.tf-sec-page__l2sv-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.tf-sec-page__l2sv-hint {\n  font-size: 12px;\n  font-weight: 500;\n  color: #8e939c;\n  line-height: 1.35;\n  white-space: normal;\n}\n\nbody.light_theme .tf-sec-page__l2sv-hint {\n  color: #6b7280;\n}\n\n.tf-sec-page__l2sv-switch.is-unbound {\n  opacity: 0.55;\n}\n\n.tf-sec-page__removed-modal {\n  text-align: center;\n}\n\n.tf-sec-page__removed-hero {\n  display: flex;\n  justify-content: center;\n  margin: 8px 0 12px;\n}\n\n.tf-sec-page__removed-hero img {\n  width: 72px;\n  height: 72px;\n  object-fit: contain;\n}\n\nbody.light_theme .tf-sec-page__l2sv-text {\n  color: #101828;\n}\n\n.tf-sec-page__l2sv-switch {\n  width: 40px;\n  height: 22px;\n  border-radius: 999px;\n  border: none;\n  background: #2b3139;\n  cursor: pointer;\n  position: relative;\n  padding: 0;\n  transition: background 0.15s ease;\n  flex: 0 0 auto;\n}\n\n.tf-sec-page__l2sv-switch.is-on {\n  background: #00a870;\n}\n\nbody.light_theme .tf-sec-page__l2sv-switch {\n  background: #DEDFE1;\n}\n\nbody.light_theme .tf-sec-page__l2sv-switch.is-on {\n  background: #111827;\n}\n\n.tf-sec-page__l2sv-knob {\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #fff;\n  transition: transform 0.15s ease;\n}\n\n.tf-sec-page__l2sv-switch.is-on .tf-sec-page__l2sv-knob {\n  transform: translateX(18px);\n}\n\n/* Withdrawal Settings modal */\n.tf-sec-page__wds-modal {\n  width: 628px;\n  max-width: 92vw;\n  border-radius: 14px;\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  background: #181a206e;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.50);\n  padding: 24px;\n  position: relative;\n}\n\nbody.light_theme .tf-sec-page__wds-modal {\n  background: rgb(255 255 255 / 20%);\n  border: 1px solid #E1E1E1;\n  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.18);\n}\n\n.tf-sec-page__wds-close {\n  position: absolute;\n  top: 12px;\n  right: 14px;\n  width: 34px;\n  height: 34px;\n  border: none;\n  background: transparent;\n  color: #84888C;\n  font-size: 22px;\n  line-height: 1;\n  cursor: pointer;\n  border-radius: 10px;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.tf-sec-page__wds-close:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #fff;\n}\n\nbody.light_theme .tf-sec-page__wds-close {\n  color: #111827;\n}\n\nbody.light_theme .tf-sec-page__wds-close:hover {\n  background: rgba(17, 24, 39, 0.06);\n  color: #111827;\n}\n\n.tf-sec-page__wds-title {\n  margin: 2px 0 6px;\n  padding-right: 44px;\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: #ffffff;\n}\n\nbody.light_theme .tf-sec-page__wds-title {\n  color: #070808;\n}\n\n.tf-sec-page__wds-subtitle {\n  margin: 0 0 14px;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.45;\n  color: #84888C;\n}\n\nbody.light_theme .tf-sec-page__wds-subtitle {\n  color: #84888c;\n}\n\n.tf-sec-page__wds-note {\n  margin: 8px 0 4px;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-size: 13px;\n  line-height: 1.4;\n}\n\n.tf-sec-page__wds-note--info {\n  background: #1e2330;\n  color: #93c5fd;\n  border: 1px solid #3b82f63d;\n}\n\nbody.light_theme .tf-sec-page__wds-note--info {\n  background: #eff6ff;\n  color: #1d4ed8;\n  border: 1px solid #bfdbfe;\n}\n\n.tf-sec-page__wds-list {\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  margin-top: 10px;\n}\n\nbody.light_theme .tf-sec-page__wds-list {\n  border-top: 1px solid #f1f5f9;\n}\n\n.tf-sec-page__wds-item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  padding: 14px 4px;\n  border-bottom: none;\n  background: transparent;\n  border-left: none;\n  border-right: none;\n  border-top: none;\n  border-radius: 0;\n  text-align: left;\n}\n\n.tf-sec-page__wds-item--link {\n  cursor: pointer;\n}\n\n.tf-sec-page__wds-left {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.tf-sec-page__wds-icon {\n  width: 18px;\n  height: 18px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n}\n\n.tf-sec-page__wds-icon img {\n  width: 18px;\n  filter: invert(1);\n  height: 18px;\n  display: block;\n  object-fit: contain;\n}\n\nbody.light_theme .tf-sec-page__wds-icon img {\n  filter: invert(0);\n}\n\n.tf-sec-page__wds-text {\n  font-size: 18px;\n  font-weight: 500;\n  color: #ffffff;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\nbody.light_theme .tf-sec-page__wds-text {\n  color: #101828;\n}\n\n.tf-sec-page__wds-right {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  flex: 0 0 auto;\n}\n\n.tf-sec-page__wds-muted {\n  font-size: 14px;\n  color: #84888C;\n  font-weight: 400;\n}\n\nbody.light_theme .tf-sec-page__wds-muted {\n  color: #101828;\n}\n\n.tf-sec-page__wds-chev {\n  font-size: 18px;\n  color: #6b7280;\n  line-height: 1;\n}\n\nbody.light_theme .tf-sec-page__wds-chev {\n  color: #9ca3af;\n}\n\n.tf-sec-page__wds-switch {\n  width: 40px;\n  height: 22px;\n  border-radius: 999px;\n  border: none;\n  background: #2b3139;\n  cursor: pointer;\n  position: relative;\n  padding: 0;\n  transition: background 0.15s ease;\n  flex: 0 0 auto;\n}\n\n.tf-sec-page__wds-switch.is-on {\n  background: #00a870;\n}\n\nbody.light_theme .tf-sec-page__wds-switch {\n  background: #DEDFE1;\n}\n\nbody.light_theme .tf-sec-page__wds-switch.is-on {\n  background: #111827;\n}\n\n.tf-sec-page__wds-knob {\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #fff;\n  transition: transform 0.15s ease;\n}\n\n.tf-sec-page__wds-switch.is-on .tf-sec-page__wds-knob {\n  transform: translateX(18px);\n}\n\n.tf-sec-page__wds-radioGroup {\n  padding-top: 10px;\n}\n\n.tf-sec-page__wds-radioRow {\n  width: 100%;\n  border: none;\n  background: transparent;\n  padding: 10px 2px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  text-align: left;\n}\n\n.tf-sec-page__wds-radio {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  background: #181a20;\n  flex: 0 0 auto;\n}\n\nbody.light_theme .tf-sec-page__wds-radio {\n  border: 2px solid #d1d5db;\n  background: #fff;\n}\n\n.tf-sec-page__wds-radioRow.is-selected .tf-sec-page__wds-radio {\n  border-color: #d1aa67;\n  box-shadow: inset 0 0 0 1px #d1aa67;\n}\n\nbody.light_theme .tf-sec-page__wds-radioRow.is-selected .tf-sec-page__wds-radio {\n  border-color: #111827;\n  box-shadow: inset 0 0 0 1px #111827;\n}\n\n.tf-sec-page__wds-radioText {\n  font-size: 14px;\n  font-weight: 500;\n  color: #ffffff;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\nbody.light_theme .tf-sec-page__wds-radioText {\n  color: #111827;\n}\n\n/* Disable account — email verification modal */\n.tf-sec-page__daev-modal {\n  width: 539px;\n  max-width: 92vw;\n  border-radius: 16px;\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  background: #181a20a3;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 28px 64px rgba(0, 0, 0, 0.50);\n  padding: 24px 24px 20px;\n  position: relative;\n}\n\nbody.light_theme .tf-sec-page__daev-modal {\n  background: rgb(255 255 255 / 20%);\n  border: 1px solid #E1E1E1;\n  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.18);\n}\n\n.tf-sec-page__daev-close {\n  position: absolute;\n  top: 14px;\n  right: 16px;\n  width: 36px;\n  height: 36px;\n  border: none;\n  background: transparent;\n  color: #84888C;\n  font-size: 22px;\n  line-height: 1;\n  cursor: pointer;\n  border-radius: 10px;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.tf-sec-page__daev-close:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #fff;\n}\n\nbody.light_theme .tf-sec-page__daev-close {\n  color: #111827;\n}\n\nbody.light_theme .tf-sec-page__daev-close:hover {\n  background: rgba(17, 24, 39, 0.06);\n  color: #111827;\n}\n\n.tf-sec-page__daev-title {\n  margin: 0 0 12px;\n  padding-right: 40px;\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: #ffffff;\n}\n\nbody.light_theme .tf-sec-page__daev-title {\n  color: #070808;\n}\n\n.tf-sec-page__daev-desc {\n  margin: 0 0 18px;\n  width: 83%;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 1.5;\n  color: #84888c;\n}\n\n.tf-sec-page__daev-label {\n  display: block;\n  margin: 0 0 8px;\n  font-size: 16px;\n  font-weight: 500;\n  color: #ffffff;\n}\n\nbody.light_theme .tf-sec-page__daev-label {\n  color: #101828;\n}\n\n.tf-sec-page__daev-inputWrap {\n  position: relative;\n  margin-bottom: 20px;\n}\n\n.tf-sec-page__daev-input {\n  width: 100%;\n  height: 48px;\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  padding: 0 100px 0 14px;\n  font-size: 15px;\n  font-weight: 500;\n  color: #ffffff;\n  background: #1e2329;\n  outline: none;\n}\n\n.tf-sec-page__daev-input:focus {\n  border-color: #d1aa67;\n  box-shadow: 0 0 0 3px rgba(252, 213, 53, 0.15);\n}\n\nbody.light_theme .tf-sec-page__daev-input {\n  border: 1px solid #e5e7eb;\n  color: #101828;\n  background: #fff;\n}\n\nbody.light_theme .tf-sec-page__daev-input:focus {\n  border-color: #707070;\n  box-shadow: 0 0 0 3px rgb(186 186 186 / 15%);\n}\n\n.tf-sec-page__daev-getCode {\n  position: absolute;\n  top: 50%;\n  right: 12px;\n  transform: translateY(-50%);\n  border: none;\n  background: transparent;\n  padding: 6px 4px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #d1aa67;\n  cursor: pointer;\n  transition: color 0.15s ease;\n}\n\n.tf-sec-page__daev-getCode:hover {\n  color: #e0be2f;\n}\n\nbody.light_theme .tf-sec-page__daev-getCode {\n  color: #c9a063;\n}\n\nbody.light_theme .tf-sec-page__daev-getCode:hover {\n  color: #b08d52;\n}\n\n.tf-sec-page__daev-submit {\n  width: 100%;\n  height: 48px;\n  border: none;\n  border-radius: 999px;\n  background: #d1aa67;\n  color: #0c0d10;\n  font-size: 15px;\n  font-weight: 700;\n  cursor: pointer;\n  margin-bottom: 16px;\n  transition: background 0.15s ease;\n}\n\n.tf-sec-page__daev-submit:hover {\n  background: #e0be2f;\n}\n\n.tf-sec-page__daev-submit:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\nbody.light_theme .tf-sec-page__daev-submit {\n  background: #2b2b2b;\n  color: #fff;\n  font-weight: 500;\n}\n\nbody.light_theme .tf-sec-page__daev-submit:hover {\n  background: #1a1a1a;\n}\n\nbody.light_theme .tf-sec-page__daev-submit:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.tf-sec-page__daev-help {\n  display: block;\n  width: 100%;\n  border: none;\n  background: transparent;\n  padding: 0;\n  margin: 7px 0 15px;\n  font-size: 16px;\n  letter-spacing: -0.40px;\n  font-weight: 600;\n  color: #d1aa67;\n  cursor: pointer;\n  text-align: center;\n}\n\n\n.gapbtn_space .tf-sec-page__daev-help {\n  margin-bottom: 0px;\n}\n\n.gapbtn_space {\n  margin-bottom: 20px;\n}\n\nbody.light_theme .tf-sec-page__daev-help {\n  color: #AC8A50;\n}\n\n.tf-sec-page__daev-footer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding-top: 16px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  margin: 0px 0px;\n  padding-left: 4px;\n  padding-right: 4px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #84888C;\n}\n\nbody.light_theme .tf-sec-page__daev-footer {\n  border-top: 1px solid #f0f0f1;\n  color: #6A7282;\n}\n\n.tf-sec-page__daev-footer img {\n  width: 18px;\n  height: 18px;\n  display: block;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n\n\n.security-verification-requirements .withdraw_sec_req_left img {\n  filter: invert(0);\n}\n\nbody.light_theme .security-verification-requirements .withdraw_sec_req_left img {\n  filter: invert(1);\n}\n\nbody.light_theme .withdraw_confirm_overlay .withdraw_sec_icon img {\n  filter: invert(1);\n}\n\n\n@media (max-width: 1440px) {\n\n  .tf-sec-page__hero-title {\n    font-size: 36px;\n  }\n\n  .tf-sec-page {\n    padding-right: 0px;\n  }\n\n\n}\n\n\n@media (max-width: 1366px) {\n\n  .tf-sec-page__hero-title {\n    font-size: 32px;\n  }\n\n  .tf-sec-page {\n    padding-right: 0px;\n    padding-left: 20px;\n  }\n\n\n}\n\n@media (max-width: 991px) {\n\n  .tf-sec-page__hero-title {\n    font-size: 30px;\n  }\n\n  .tf-sec-page__card-title {\n    font-size: 16px;\n  }\n\n  .tf-sec-page__row-main {\n    width: 60%;\n    align-items: center;\n  }\n\n  .tf-sec-page {\n    padding-left: 0px;\n  }\n\n  .tf-sec-page__row {\n    padding: 20px 0px;\n    border: none;\n  }\n\n  .tf-sec-page__hero {\n    margin: 10px 0 10px;\n  }\n\n\n  .tf-sec-page__card {\n    border: none;\n    border-radius: 0px;\n    margin-bottom: 24px;\n    box-shadow: none;\n    border-bottom: 1px solid #ededed26;\n  }\n\n  body.light_theme .tf-sec-page__card {\n    border-bottom: 1px solid #ededed;\n  }\n\n  .tf-sec-page__card-header {\n    padding: 9px 0px;\n    border-bottom: none;\n  }\n\n  .tf-sec-page__row-description {\n    display: none;\n  }\n\n  .tf-sec-page__row-heading {\n    font-size: 16px;\n    font-weight: 500;\n  }\n\n}\n\n\n@media (max-width: 767px) {\n\n  .tf-sec-page__hero-title {\n    font-size: 24px;\n  }\n\n  .tf-sec-page {\n    padding-left: 0px;\n  }\n\n  .tf-sec-page__hero {\n    margin: 0px 0 10px;\n    flex-wrap: nowrap;\n    align-items: center;\n  }\n\n  .tf-sec-page__card {\n    margin-bottom: 20px;\n  }\n\n  .tf-sec-page__l2sv-overlay,\n  .tf-sec-page__wds-overlay,\n  .tf-sec-page__daev-overlay {\n    align-items: end;\n    padding: 0px;\n  }\n\n  .tf-sec-page__daev-title {\n    font-size: 20px;\n  }\n\n  .tf-sec-page__daev-modal {\n    max-width: 100%;\n    border-radius: 16px 16px 0px 0px;\n  }\n\n  .tf-sec-page__daev-submit {\n    height: 42px;\n    font-size: 14px;\n  }\n\n  .tf-sec-page__hero-description {\n    display: none;\n  }\n\n  .tf-sec-page__hero-media {\n    max-width: 100px;\n  }\n\n  .tf-sec-page__l2sv-modal {\n    max-width: 100%;\n    border-radius: 14px 14px 0px 0px;\n  }\n\n  .tf-sec-page__l2sv-title {\n    font-size: 20px;\n  }\n\n  .tf-sec-page__l2sv-text {\n    font-size: 15px;\n  }\n\n  .tf-sec-page__unbound-overlay {\n    align-items: end;\n  }\n\n  .tf-sec-page__wds-text {\n    font-size: 15px;\n  }\n\n  .tf-sec-page__wds-title {\n    font-size: 20px;\n  }\n\n  .tf-sec-page__wds-modal {\n    max-width: 100%;\n    border-radius: 14px 14px 0px 0px;\n    width: 100%;\n  }\n\n  .tf-sec-page__unbound-title {\n    font-size: 20px;\n  }\n\n  .tf-sec-page__fundpw-title {\n    font-size: 20px;\n  }\n\n  .tf-sec-page__fundpw-cta {\n    height: 42px;\n    font-size: 15px;\n  }\n\n  .tf-sec-page__fundpw-modal {\n    max-width: 100%;\n    border-radius: 16px 16px 0px 0px;\n  }\n\n  .tf-sec-page__unbound-modal {\n    max-width: 100%;\n    max-height: 70vh;\n    overflow: auto;\n    min-height: 35vh;\n    border-radius: 16px 16px 0px 0px;\n  }\n\n  .tf-sec-page__unbound-cta {\n    height: 42px;\n    font-size: 14px;\n  }\n\n  .tf-sec-page__fundpw-overlay {\n    align-items: end;\n  }\n\n  .tf-sec-page__fpw-confirm-modal {\n    width: 100%;\n    border-radius: 16px 16px 0px 0px;\n  }\n\n  .tf-sec-page__fpw-confirm-title {\n    padding: 0 15px;\n    font-size: 20px;\n  }\n\n  .tf-sec-page__fpw-confirm-art {\n    width: 160px;\n  }\n\n  .tf-sec-page__fpw-confirm-cancel,\n  .tf-sec-page__fpw-confirm-ok {\n    min-height: 42px;\n    font-size: 14px;\n  }\n\n  .tf-sec-page__row-icon-wrap {\n    display: none;\n  }\n\n}\n\n\n@media (max-width: 580px) {\n\n  .tf-sec-page__hero-title {\n    font-size: 20px;\n  }\n\n\n  .tf-sec-vault__card.is-live {\n    box-shadow: inset 1px 0 0 #a4ebbe;\n  }\n\n  .tf-sec-page__row-main {\n    width: 100%;\n  }\n\n  .tf-sec-page__btn {\n    padding: 5px 1px;\n    min-width: 70px;\n    font-size: 12px;\n  }\n\n  .tf-sec-page__method-list .tf-sec-page__btn {\n    padding: 10px 20px;\n  }\n\n  .tf-sec-page__row-heading {\n    font-size: 14px;\n  }\n\n  .tf-sec-page__row-meta {\n    min-width: auto;\n  }\n\n  .tf-sec-page__status {\n    gap: 3px;\n    font-size: 12px;\n  }\n\n  .tf_checkfill {\n    font-size: 10px;\n    width: 14px;\n    height: 14px;\n  }\n\n\n}\n\n/* ── Withdrawal settings inline verification step ── */\n.tf-sec-page__wds-verify {\n  padding: 16px 0 8px;\n  border-top: 1px solid #f1f5f9;\n}\n\n.tf-sec-page__wds-verify-label {\n  font-size: 13px;\n  color: #374151;\n  margin-bottom: 10px;\n  line-height: 1.4;\n}\n\n.tf-sec-page__wds-verify-input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 10px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 14px;\n  outline: none;\n  transition: border-color 0.15s;\n}\n\n.tf-sec-page__wds-verify-input:focus {\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);\n}\n\n.tf-sec-page__wds-verify-error {\n  margin: 6px 0 0;\n  font-size: 12px;\n  color: #dc2626;\n}\n\n.tf-sec-page__wds-verify-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 12px;\n  justify-content: flex-end;\n}\n\n.tf-sec-page__wds-verify-btn {\n  padding: 8px 18px;\n  border-radius: 8px;\n  border: none;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s, opacity 0.15s;\n}\n\n.tf-sec-page__wds-verify-btn--cancel {\n  background: #f1f5f9;\n  color: #374151;\n}\n\n.tf-sec-page__wds-verify-btn--cancel:hover {\n  background: #e2e8f0;\n}\n\n.tf-sec-page__wds-verify-btn--confirm {\n  background: #3b82f6;\n  color: #fff;\n}\n\n.tf-sec-page__wds-verify-btn--confirm:hover {\n  background: #2563eb;\n}\n\n.tf-sec-page__wds-verify-btn--confirm:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* —— Protection vault — premium client dashboard —— */\n.tf-sec-vault {\n  margin-bottom: 24px;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n}\n\n.tf-sec-vault__panel {\n  position: relative;\n  overflow: visible;\n  border-radius: 16px;\n  border: 1px solid #f3f4f60a;\n  background: #181a20;\n  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.22);\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n}\n\nbody.light_theme .tf-sec-vault__panel {\n  border: 1px solid #f3f4f638;\n}\n\n.tf-sec-vault__panel::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  border-radius: inherit;\n  pointer-events: none;\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.04);\n}\n\nbody.light_theme .tf-sec-vault__panel::after {\n  box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.04);\n}\n\nbody.light_theme .tf-sec-vault__panel {\n  border-color: #f3f4f6;\n  background: linear-gradient(180deg, #ffffff 0%, #faf7f1 100%);\n  box-shadow: 0 12px 36px rgba(15, 23, 42, 0.07);\n}\n\n.tf-sec-vault__accent {\n  display: none;\n}\n\n/* Override global `header { height: 60px }` if a header tag is ever used here */\n.tf-sec-vault__header {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  height: auto;\n  padding: 14px 16px 12px;\n  margin: 0;\n  background: transparent;\n  border-bottom: 1px solid #f3f4f60a;\n}\n\nbody.light_theme .tf-sec-vault__header {\n  border-bottom-color: #f3f4f6;\n}\n\n.tf-sec-vault__orb {\n  --vault-progress: 0%;\n  position: relative;\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  padding: 3px;\n  flex-shrink: 0;\n  background: conic-gradient(var(--tf-green, #00a870) var(--vault-progress), rgba(148, 163, 184, 0.2) 0);\n}\n\n.tf-sec-vault__orb-inner {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n  background: linear-gradient(180deg, rgba(20, 24, 34, 1) 0%, rgba(12, 14, 20, 1) 100%);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n}\n\nbody.light_theme .tf-sec-vault__orb-inner {\n  background: linear-gradient(180deg, #ffffff 0%, #f8f4ec 100%);\n  border-color: #f0e0c4;\n}\n\n.tf-sec-vault__orb-inner>i {\n  font-size: 18px;\n  color: var(--tf-green, #00a870);\n}\n\n.tf-sec-vault__orb-count {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 1px;\n  line-height: 1;\n}\n\n.tf-sec-vault__orb-score {\n  font-size: 18px;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  color: #f8fafc;\n}\n\nbody.light_theme .tf-sec-vault__orb-score {\n  color: #0f172a;\n}\n\n.tf-sec-vault__orb-total {\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--tf-muted);\n}\n\n.tf-sec-vault__intro {\n  flex: 1;\n  min-width: 0;\n}\n\n.tf-sec-vault__kicker {\n  margin: 0 0 2px;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: #d1aa67;\n}\n\n.tf-sec-vault__headline {\n  margin: 0;\n  font-size: 17px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: #f8fafc;\n  line-height: 1.2;\n}\n\nbody.light_theme .tf-sec-vault__headline {\n  color: #101828;\n}\n\n.tf-sec-vault__subtitle {\n  margin: 3px 0 0;\n  font-size: 12px;\n  line-height: 1.4;\n  color: var(--tf-muted);\n  max-width: 480px;\n}\n\n.tf-sec-vault__summary {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 6px;\n  flex-shrink: 0;\n}\n\n.tf-sec-vault__coverage {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  padding: 7px 11px;\n  border-radius: 10px;\n  border: 1px solid #353a42;\n  background: #1f2127;\n  min-width: 80px;\n  --vault-coverage: 0%;\n}\n\n.tf-sec-vault__coverage-meta {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\nbody.light_theme .tf-sec-vault__coverage {\n  background: #f0fdf4;\n  border-color: #bbf7d0;\n}\n\n.tf-sec-vault__coverage-value {\n  font-size: 20px;\n  font-weight: 800;\n  line-height: 1;\n  letter-spacing: -0.03em;\n  color: #4ade80;\n}\n\nbody.light_theme .tf-sec-vault__coverage-value {\n  color: #16a34a;\n}\n\n.tf-sec-vault__coverage-label {\n  margin-top: 2px;\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--tf-muted);\n}\n\n.tf-sec-vault__coverage-track {\n  display: none;\n}\n\n.tf-sec-vault__coverage-fill {\n  height: 100%;\n  width: var(--vault-coverage);\n  border-radius: inherit;\n  background: linear-gradient(90deg, #16a34a 0%, #4ade80 100%);\n}\n\n.tf-sec-vault__grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px;\n  padding: 10px 14px 12px;\n}\n\n.tf-sec-vault__card {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 9px 10px 9px 12px;\n  border-radius: 12px;\n  background: #94a3b80f;\n  border: 1px solid #94a3b80f;\n  /* box-shadow: inset 3px 0 0 rgba(148, 163, 184, 0.35); */\n}\n\nbutton.tf-sec-vault__card--action {\n  width: 100%;\n  margin: 0;\n  font: inherit;\n  color: inherit;\n  text-align: left;\n  cursor: pointer;\n  appearance: none;\n  -webkit-appearance: none;\n  transition: border-color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;\n}\n\nbutton.tf-sec-vault__card--action:hover {\n\n  border-color: rgb(59 63 72);\n  background: rgb(30 34 42);\n  /* box-shadow: inset 3px 0 0 #353a42; */\n}\n\nbutton.tf-sec-vault__card--action:focus-visible {\n  outline: 2px solid #d1aa67;\n  outline-offset: 2px;\n}\n\nbody.light_theme button.tf-sec-vault__card--action:hover {\n  border-color: rgb(59 63 72 / 16%);\n  background: rgb(242 243 247);\n  /* box-shadow: inset 3px 0 0 #353a4240; */\n}\n\nbody.light_theme .tf-sec-vault__card {\n  background: #ffffff;\n  border-color: #eef2f7;\n  /* box-shadow: inset 3px 0 0 #e2e8f0; */\n}\n\n.tf-sec-vault__card.is-live {\n  /* background: linear-gradient(135deg, rgba(34, 197, 94, 0.1) 0%, rgba(255, 255, 255, 0.02) 100%); */\n  /* border-color: #a4ebbe6e;\n  box-shadow: inset 3px 0 0 #a4ebbe85; */\n}\n\n/* body.light_theme .tf-sec-vault__card.is-live {\n  background: linear-gradient(135deg, #f0fdf4 0%, #ffffff 100%);\n  border-color: #bbf7d0;\n  box-shadow: inset 3px 0 0 #bbf7d0;\n} */\n\n.tf-sec-vault__card-icon {\n  width: 34px;\n  height: 34px;\n  border-radius: 9px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  font-size: 17px;\n  color: #94a3b8;\n  background: rgba(148, 163, 184, 0.1);\n  border: 1px solid rgba(148, 163, 184, 0.16);\n}\n\nbody.light_theme .tf-sec-vault__card-icon {\n  background: #f8fafc;\n  border-color: #e8edf3;\n}\n\n.tf-sec-vault__card.is-live .tf-sec-vault__card-icon {\n  color: #94a3b8;\n  /* background: rgba(34, 197, 94, 0.14);\n  border-color: rgba(34, 197, 94, 0.3); */\n}\n\n/* body.light_theme .tf-sec-vault__card.is-live .tf-sec-vault__card-icon {\n  color: #16a34a;\n  background: #dcfce7;\n  border-color: #bbf7d0;\n} */\n\n.tf-sec-vault__card-body {\n  min-width: 0;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 4px 6px;\n}\n\n.tf-sec-vault__card-title {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: #e2e8f0;\n  line-height: 1.2;\n}\n\nbody.light_theme .tf-sec-vault__card-title {\n  color: #1e293b;\n}\n\n.tf-sec-vault__card.is-live .tf-sec-vault__card-title {\n  color: #dcfce7;\n}\n\nbody.light_theme .tf-sec-vault__card.is-live .tf-sec-vault__card-title {\n  color: #333333;\n}\n\n.tf-sec-vault__card-badge {\n  display: inline-flex;\n  margin-top: 0;\n  padding: 1px 7px;\n  border-radius: 999px;\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  color: #94a3b8;\n  background: rgba(148, 163, 184, 0.12);\n}\n\nbody.light_theme .tf-sec-vault__card-badge {\n  color: #64748b;\n  background: #f1f5f9;\n}\n\n.tf-sec-vault__card-badge.is-live {\n  color: #94a3ac;\n  background: rgb(41 45 50);\n}\n\n/* body.light_theme .tf-sec-vault__card-badge.is-live {\n  color: #16a34a;\n  background: #dcfce7;\n} */\n\n.tf-sec-vault__card-check {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  font-size: 12px;\n  color: #64748b;\n  background: rgba(148, 163, 184, 0.12);\n  border: 1px solid rgba(148, 163, 184, 0.18);\n}\n\nbody.light_theme .tf-sec-vault__card-check {\n  background: #f8fafc;\n  border-color: #e2e8f0;\n}\n\n.tf-sec-vault__card-check.is-live {\n  color: var(--tf-green, #00a870);\n  background: transparent;\n  border-color: var(--tf-green, #00a870);\n}\n\n.tf-sec-vault__card-check.is-live i {\n  font-weight: 700;\n}\n\n@media (max-width: 1200px) {\n\n  .tf-sec-page__row-meta {\n    min-width: auto;\n  }\n\n  .tf-sec-page__row-actions {\n    min-width: 150px;\n  }\n\n  .tf-sec-page__row {\n    padding: 24px 32px 24px 24px;\n  }\n\n  .tf-sec-vault__header {\n    flex-wrap: wrap;\n  }\n\n  .tf-sec-vault__summary {\n    width: 100%;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-end;\n  }\n\n  .tf-sec-vault__coverage {\n    flex-direction: row;\n    align-items: center;\n    gap: 8px;\n    min-width: 0;\n  }\n\n  .tf-sec-vault__coverage-meta {\n    flex-direction: row;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .tf-sec-vault__coverage-label {\n    margin-top: 0;\n  }\n}\n\n\n@media (max-width:991px) {\n\n  .tf-sec-page__row {\n    padding: 20px 0px 20px 0px;\n  }\n\n  .tf-sec-page__row-actions {\n    min-width: 240px;\n  }\n\n}\n\n\n/* —— Mobile: compact premium dashboard tiles —— */\n@media (max-width: 767px) {\n\n\n  .tf-sec-page__row-actions {\n    min-width: 110px;\n    max-width: 110px;\n  }\n\n  .tf-sec-page__card .tf-sec-page__row-meta {\n    min-width: 100px;\n    text-align: right;\n  }\n\n  .tf-sec-vault {\n    margin-bottom: 16px;\n  }\n\n  .tf-sec-vault__panel {\n    border-radius: 16px;\n    box-shadow: 0 8px 28px rgba(15, 23, 42, 0.06);\n  }\n\n  body.light_theme .tf-sec-vault__panel {\n    background: #ffffff;\n  }\n\n  .tf-sec-vault__header {\n    display: grid;\n    grid-template-columns: auto minmax(0, 1fr);\n    grid-template-areas:\n      \"orb intro\"\n      \"coverage coverage\";\n    align-items: center;\n    gap: 12px;\n    padding: 16px 14px 14px;\n  }\n\n  .tf-sec-vault__orb {\n    grid-area: orb;\n    width: 68px;\n    height: 68px;\n  }\n\n  .tf-sec-vault__orb-inner>i {\n    font-size: 15px;\n  }\n\n  .tf-sec-vault__orb-score {\n    font-size: 17px;\n  }\n\n  .tf-sec-vault__orb-total {\n    font-size: 11px;\n  }\n\n  .tf-sec-vault__intro {\n    grid-area: intro;\n  }\n\n  .tf-sec-vault__kicker {\n    margin-bottom: 3px;\n    font-size: 9px;\n  }\n\n  .tf-sec-vault__headline {\n    font-size: 15px;\n    line-height: 1.25;\n  }\n\n  .tf-sec-vault__subtitle {\n    margin-top: 4px;\n    font-size: 12px;\n    line-height: 1.4;\n    max-width: none;\n  }\n\n  .tf-sec-vault__summary {\n    grid-area: coverage;\n    width: 100%;\n  }\n\n  .tf-sec-vault__coverage {\n    width: 100%;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 8px;\n    padding: 10px 12px;\n    border-radius: 12px;\n    min-width: 0;\n  }\n\n  .tf-sec-vault__coverage-meta {\n    width: 100%;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .tf-sec-vault__coverage-label {\n    margin-top: 0;\n    order: -1;\n    font-size: 10px;\n  }\n\n  .tf-sec-vault__coverage-value {\n    font-size: 18px;\n  }\n\n  .tf-sec-vault__coverage-track {\n    display: block;\n    width: 100%;\n    height: 6px;\n    border-radius: 999px;\n    overflow: hidden;\n    background: rgba(148, 163, 184, 0.2);\n  }\n\n  body.light_theme .tf-sec-vault__coverage-track {\n    background: #dcfce7;\n  }\n\n  .tf-sec-vault__grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 5px;\n    padding: 6px 8px 8px;\n  }\n\n  .tf-sec-vault__card {\n    position: relative;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 3px;\n    min-height: 0;\n    min-width: 0;\n    padding: 5px 8px;\n    border-radius: 8px;\n    box-shadow: none;\n  }\n\n  body.light_theme .tf-sec-vault__card {\n    box-shadow: none;\n  }\n\n  body.light_theme .tf-sec-vault__card.is-live {\n    box-shadow: none;\n  }\n\n  .tf-sec-vault__card-icon {\n    width: 20px;\n    height: 20px;\n    font-size: 11px;\n    border-radius: 6px;\n  }\n\n  .tf-sec-vault__card-check {\n    position: absolute;\n    top: 4px;\n    right: 4px;\n    width: 14px;\n    height: 14px;\n    font-size: 8px;\n  }\n\n  .tf-sec-vault__card-body {\n    width: 100%;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 2px;\n    padding-right: 2px;\n  }\n\n  .tf-sec-vault__card-title {\n    font-size: 10px;\n    font-weight: 700;\n    line-height: 1.1;\n    word-break: break-word;\n  }\n\n  .tf-sec-vault__card-badge {\n    padding: 0 4px;\n    font-size: 6px;\n    letter-spacing: 0.02em;\n  }\n\n  .tf-sec-page__status-email {\n    font-size: 12px;\n    word-break: break-all;\n  }\n}\n\n@media (max-width: 480px) {\n\n  .tf-sec-page__l2sv-row-icons {\n    display: none;\n  }\n\n  .tf-sec-page__row-heading-line {\n    gap: 0px;\n  }\n\n  .tf-sec-page__badge {\n    font-size: 10px;\n  }\n\n  .tf-sec-page__row-actions {\n    min-width: 90px;\n    max-width: 90px;\n  }\n\n}\n\n@media (max-width: 380px) {\n\n  .tf-sec-page__row {\n    align-items: center;\n  }\n\n\n  .tf-sec-vault__header {\n    padding: 14px 12px 12px;\n    gap: 10px;\n  }\n\n  .tf-sec-vault__orb {\n    width: 60px;\n    height: 60px;\n  }\n\n  .tf-sec-vault__headline {\n    font-size: 14px;\n  }\n\n  .tf-sec-page__status-email {\n    font-size: 12px;\n  }\n\n  .tf-sec-vault__subtitle {\n    font-size: 11px;\n  }\n\n  .tf-sec-vault__grid {\n    gap: 4px;\n    padding: 5px 6px 6px;\n  }\n\n  .tf-sec-vault__card {\n    gap: 2px;\n    border-radius: 7px;\n  }\n\n  .tf-sec-vault__card-icon {\n    width: 18px;\n    height: 18px;\n    font-size: 10px;\n  }\n\n  .tf-sec-vault__card-check {\n    width: 12px;\n    height: 12px;\n    font-size: 7px;\n    top: 3px;\n    right: 3px;\n  }\n\n  .tf-sec-vault__card-title {\n    font-size: 9px;\n  }\n\n  .tf-sec-vault__card-badge {\n    padding: 0 3px;\n    font-size: 6px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
